(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7536],{

/***/ 78000:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AmpStateContext = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var AmpStateContext = _react["default"].createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ 9470:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isInAmpMode = isInAmpMode;

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

/***/ }),

/***/ 72717:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaultHead = defaultHead;
exports["default"] = void 0;

var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(67294));

var _sideEffect = _interop_require_default(__webpack_require__(11585));

var _ampContext = __webpack_require__(78000);

var _headManagerContext = __webpack_require__(15850);

var _ampMode = __webpack_require__(9470);

var _utils = __webpack_require__(99475);

'client';

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react["default"].createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react["default"].createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react["default"].Fragment) {
    return list.concat(_react["default"].Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
 returns a function for filtering head child elements
 which shouldn't be duplicated, like <title/>
 Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;
    var hasKey = false;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      hasKey = true;
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if ((metatype !== 'name' || !hasKey) && categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
 *
 * @param headChildrenElements List of children of <Head>
 */


function reduceComponents(headChildrenElements, props) {
  var inAmpMode = props.inAmpMode;
  return headChildrenElements.reduce(onlyReactElement, []).reverse().concat(defaultHead(inAmpMode).reverse()).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if ( true && !inAmpMode) {
      if (c.type === 'link' && c.props['href'] && // TODO(prateekbh@): Replace this with const from `constants` when the tree shaking works.
      ['https://fonts.googleapis.com/css', 'https://use.typekit.net/'].some(function (url) {
        return c.props['href'].startsWith(url);
      })) {
        var newProps = _extends({}, c.props || {});

        newProps['data-href'] = newProps['href'];
        newProps['href'] = undefined; // Add this attribute to make it easy to identify optimized tags

        newProps['data-optimized-fonts'] = true;
        return /*#__PURE__*/_react["default"].cloneElement(c, newProps);
      }
    }

    if (false) { var srcMessage; }

    return /*#__PURE__*/_react["default"].cloneElement(c, {
      key: key
    });
  });
}
/**
 * This component injects elements to `<head>` of your page.
 * To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
 */


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react).useContext(_ampContext.AmpStateContext);
  var headManager = (0, _react).useContext(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react["default"].createElement(_sideEffect["default"], {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _ampMode).isInAmpMode(ampState)
  }, children);
}

var _default = Head;
exports["default"] = _default;

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 11585:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = SideEffect;

var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(67294));

function SideEffect(props) {
  var headManager = props.headManager,
      reduceComponentsToState = props.reduceComponentsToState;

  function emitChange() {
    if (headManager && headManager.mountedInstances) {
      var headElements = _react.Children.toArray(Array.from(headManager.mountedInstances).filter(Boolean));

      headManager.updateHead(reduceComponentsToState(headElements, props));
    }
  }

  if (isServer) {
    var ref;
    headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref.add(props.children);
    emitChange();
  }

  useClientOnlyLayoutEffect(function () {
    var ref1;
    headManager == null ? void 0 : (ref1 = headManager.mountedInstances) == null ? void 0 : ref1.add(props.children);
    return function () {
      var ref;
      headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref["delete"](props.children);
    };
  }); // We need to call `updateHead` method whenever the `SideEffect` is trigger in all
  // life-cycles: mount, update, unmount. However, if there are multiple `SideEffect`s
  // being rendered, we only trigger the method from the last one.
  // This is ensured by keeping the last unflushed `updateHead` in the `_pendingUpdate`
  // singleton in the layout effect pass, and actually trigger it in the effect pass.

  useClientOnlyLayoutEffect(function () {
    if (headManager) {
      headManager._pendingUpdate = emitChange;
    }

    return function () {
      if (headManager) {
        headManager._pendingUpdate = emitChange;
      }
    };
  });
  useClientOnlyEffect(function () {
    if (headManager && headManager._pendingUpdate) {
      headManager._pendingUpdate();

      headManager._pendingUpdate = null;
    }

    return function () {
      if (headManager && headManager._pendingUpdate) {
        headManager._pendingUpdate();

        headManager._pendingUpdate = null;
      }
    };
  });
  return null;
}

var isServer = false;
var useClientOnlyLayoutEffect = isServer ? function () {} : _react.useLayoutEffect;
var useClientOnlyEffect = isServer ? function () {} : _react.useEffect;

/***/ }),

/***/ 42444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ FranchiseLanding; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ./shared/components-pages/franquicias-landing/model.ts




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var DRAFT_KEY = "franquicias-demo-v1";
var TIME_ZONE = "America/Santo_Domingo";
var intentions = ["Adquirir una franquicia y dirigir mi propia oficina", "Invertir en un negocio con una marca ya establecida", "Trabajar como agente inmobiliario", "Solo estoy explorando información general"];
var capitals = ["Entre US$8,000 y US$15,000", "Entre US$15,000 y US$30,000", "Entre US$30,000 y US$50,000", "Más de US$50,000"];
var zones = ["Santiago", "La Vega / Bonao", "San Francisco de Macorís / Nordeste", "Puerto Plata / Costa Norte", "San Cristóbal / Sur", "Punta Cana", "Este (Higüey, La Romana)", "Santo Domingo / Distrito Nacional", "Aún no lo he definido"];
var hours = ["9:00 a.m.", "10:00 a.m.", "11:00 a.m.", "2:00 p.m.", "3:00 p.m.", "4:00 p.m.", "5:00 p.m."];
var emptyAnswers = {
  intencion: "",
  capital: "",
  zona: "",
  nombre: "",
  telefono: "",
  email: "",
  consent: false
};
var emptyAppointment = {
  fecha: "",
  hora: ""
};
var normalizeName = function normalizeName(value) {
  return value.trim().replace(/\s+/g, " ");
};
function contactErrors(a) {
  return {
    nombre: normalizeName(a.nombre).length < 3 || !normalizeName(a.nombre).includes(" "),
    telefono: a.telefono.replace(/\D/g, "").length < 10,
    email: !/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(a.email.trim()),
    consent: !a.consent
  };
}
function localDate() {
  var now = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).formatToParts(now);
  return ["year", "month", "day"].map(function (k) {
    return parts.find(function (p) {
      return p.type === k;
    }).value;
  }).join("-");
}
function businessDays() {
  var now = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var day = new Date(localDate(now) + "T12:00:00Z"),
      result = [];

  while (result.length < 14) {
    day.setUTCDate(day.getUTCDate() + 1);
    if (![0, 6].includes(day.getUTCDay())) result.push(day.toISOString().slice(0, 10));
  }

  return result;
}
function isBusy(date, index) {
  var d = new Date(date + "T12:00:00Z");
  return (d.getUTCDate() * 31 + d.getUTCMonth() * 7 + index * 13) % 10 < 3;
}
var dateLabel = function dateLabel(date) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    weekday: "short",
    day: "numeric",
    month: "long"
  };
  return new Intl.DateTimeFormat("es-DO", _objectSpread(_objectSpread({}, options), {}, {
    timeZone: TIME_ZONE
  })).format(new Date(date + "T12:00:00Z"));
};
function validAppointment(a) {
  var dates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : businessDays();
  return dates.includes(a.fecha) && hours.includes(a.hora) && !isBusy(a.fecha, hours.indexOf(a.hora));
}
function previous(step) {
  return {
    intro: "intro",
    p1: "intro",
    p2: "p1",
    p3: "p2",
    p4: "p3",
    p5: "p4",
    pa: "p1",
    pb: "p1",
    ok: "intro"
  }[step];
}
function restoreDraft(raw) {
  try {
    var value = JSON.parse(raw || "null");
    if (!value || value.version !== 1 || !value.answers || !["intro", "p1", "p2", "p3", "p4", "p5", "pa", "pb"].includes(value.step)) return null;

    var answers = _objectSpread({}, emptyAnswers);

    Object.keys(answers).forEach(function (key) {
      if (key === "consent") answers.consent = value.answers.consent === true;else if (typeof value.answers[key] === "string") answers[key] = value.answers[key].slice(0, 500);
    });
    if (!intentions.includes(answers.intencion)) answers.intencion = "";
    if (!capitals.includes(answers.capital)) answers.capital = "";
    if (!zones.includes(answers.zona)) answers.zona = "";
    var step = value.step;

    if (step === "pa" || step === "pb") {
      if (answers.intencion !== intentions[step === "pa" ? 2 : 3]) step = "p1";
    }

    if (["p2", "p3", "p4", "p5"].includes(step) && !intentions.slice(0, 2).includes(answers.intencion)) step = "p1";
    if (["p3", "p4", "p5"].includes(step) && !answers.capital) step = "p2";
    if (["p4", "p5"].includes(step) && !answers.zona) step = "p3";
    if (step === "p5" && Object.values(contactErrors(answers)).some(Boolean)) step = "p4";
    var dates = businessDays();

    var appointment = _objectSpread({}, emptyAppointment);

    if (value.appointment && dates.includes(value.appointment.fecha)) {
      appointment.fecha = value.appointment.fecha;
      if (validAppointment(value.appointment, dates)) appointment.hora = value.appointment.hora;
    }

    return {
      version: 1,
      step: step,
      answers: answers,
      appointment: appointment
    };
  } catch (_unused) {
    return null;
  }
}
function attribution(url) {
  var params = new URL(url).searchParams;
  var result = {};
  ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "utm_id", "fbclid", "gclid"].forEach(function (k) {
    var v = params.get(k);
    if (v) result[k] = v.slice(0, 500);
  });
  return result;
}
function buildLead(answers, appointment, url, requestId) {
  if (Object.values(contactErrors(answers)).some(Boolean) || !intentions.slice(0, 2).includes(answers.intencion) || !capitals.includes(answers.capital) || !zones.includes(answers.zona) || !validAppointment(appointment)) throw new Error("Revisa tus respuestas antes de continuar.");
  var timestamp = new Date().toISOString();
  var page = new URL(url);
  page.search = "";
  page.hash = "";
  return {
    version: 1,
    requestId: requestId,
    formulario: "FRQ2026_TuDiriges_Intencion_v2",
    intencion: answers.intencion,
    capital: answers.capital,
    zona: answers.zona,
    nombre: normalizeName(answers.nombre),
    telefono: answers.telefono.replace(/\D/g, ""),
    email: answers.email.trim().toLowerCase(),
    consentimiento: {
      accepted: true,
      version: "frq-contact-v1",
      timestamp: timestamp
    },
    prioridad: capitals.indexOf(answers.capital) >= 2 ? "alta" : "normal",
    cita: _objectSpread(_objectSpread({}, appointment), {}, {
      timeZone: TIME_ZONE
    }),
    utm: attribution(url),
    pagina: page.toString(),
    timestamp: timestamp
  };
}
// No network or persistent contact storage: production transport belongs on our server in phase two.
var demoTransport = {
  submit: function submit(lead) {
    return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", {
                status: "demo-complete",
                requestId: lead.requestId
              });

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};
var demoAgenda = {
  days: businessDays,
  available: function available(date, hour) {
    return hours.includes(hour) && !isBusy(date, hours.indexOf(hour));
  }
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(81531);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(90607);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/isNativeFunction.js
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/construct.js


function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) (0,setPrototypeOf/* default */.Z)(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/wrapNativeSuper.js




function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, (0,getPrototypeOf/* default */.Z)(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return (0,setPrototypeOf/* default */.Z)(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}
;// CONCATENATED MODULE: ./shared/components-pages/franquicias-landing/hubspotTransport.ts









function _createSuper(Derived) { var hasNativeReflectConstruct = hubspotTransport_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function hubspotTransport_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LeadSubmissionError = /*#__PURE__*/function (_Error) {
  (0,inherits/* default */.Z)(LeadSubmissionError, _Error);

  var _super = _createSuper(LeadSubmissionError);

  function LeadSubmissionError(code) {
    var _this;

    (0,classCallCheck/* default */.Z)(this, LeadSubmissionError);

    _this = _super.call(this, code === "confirmation_pending" ? "Estamos verificando la recepción. No envíes otra solicitud; consulta con el equipo." : code === "integration_disabled" || code === "configuration_required" ? "El formulario todavía no está habilitado para envíos reales." : "No se pudo confirmar el envío. Conservamos tus respuestas.");
    _this.code = code;
    return _this;
  }

  return (0,createClass/* default */.Z)(LeadSubmissionError);
}( /*#__PURE__*/_wrapNativeSuper(Error)); // Separate from the demo payload: no simulated appointment is sent as a real booking.

function submitWebLead(_x) {
  return _submitWebLead.apply(this, arguments);
}

function _submitWebLead() {
  _submitWebLead = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(lead) {
    var fetcher,
        response,
        result,
        _args = arguments;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            fetcher = _args.length > 1 && _args[1] !== undefined ? _args[1] : fetch;
            _context.next = 3;
            return fetcher("/api/franquicias/leads", {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify(lead),
              credentials: "same-origin"
            });

          case 3:
            response = _context.sent;
            _context.next = 6;
            return response.json();

          case 6:
            result = _context.sent;

            if (response.ok) {
              _context.next = 9;
              break;
            }

            throw new LeadSubmissionError(result.code || "temporarily_unavailable");

          case 9:
            if (!(result.status !== "accepted" || result.requestId !== lead.requestId)) {
              _context.next = 11;
              break;
            }

            throw new LeadSubmissionError("invalid_response");

          case 11:
            return _context.abrupt("return", {
              status: "accepted",
              requestId: lead.requestId
            });

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _submitWebLead.apply(this, arguments);
}
;// CONCATENATED MODULE: ./shared/components-pages/franquicias-landing/meeting.ts
var MEETING_URL = "https://meetings.hubspot.com/melissazabala";
function bookingUrl(contact) {
  var url = new URL(MEETING_URL);
  url.searchParams.set("embed", "true"); // HubSpot uses these values to identify reservations made from this landing.

  url.searchParams.set("utm_source", "web-Leads-Franquicias-2026");
  url.searchParams.set("utm_medium", "landing");
  url.searchParams.set("utm_campaign", "reserva-Leads-Franquicias-2026");

  if (contact) {
    url.searchParams.set("firstName", contact.firstname);
    url.searchParams.set("lastName", contact.lastname);
    url.searchParams.set("email", contact.email);
  }

  return url.toString();
}
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components-pages/franquicias-landing/LiveContactAgenda.tsx




function LiveContactAgenda_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LiveContactAgenda_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LiveContactAgenda_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LiveContactAgenda_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var KEY = "franquicias-live-contact-v1";
var PREPARING = "Estamos preparando tu solicitud para que puedas agendar.";
var fields = {
  firstname: ["Nombre", "given-name", "text"],
  lastname: ["Apellidos", "family-name", "text"],
  email: ["Correo electrónico", "email", "email"],
  phone: ["Teléfono", "tel", "tel"]
};
var empty = {
  firstname: "",
  lastname: "",
  email: "",
  phone: "",
  consent: false
};

var normalized = function normalized(s) {
  return s.trim().replace(/\s+/g, " ");
};

function contactIssues(c) {
  return {
    firstname: !normalized(c.firstname) || c.firstname.length > 100,
    lastname: !normalized(c.lastname) || c.lastname.length > 100,
    email: !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(c.email.trim()),
    phone: !/^\+?[1-9]\d{9,14}$/.test(c.phone.replace(/[\s().-]/g, "")),
    consent: !c.consent
  };
}

function restoredRequest(value) {
  if (!value || typeof value !== "object") return false;
  var s = value;
  return s.version === 2 && typeof s.requestId === "string" && /^[a-f\d]{8}-[a-f\d]{4}-4[a-f\d]{3}-[89ab][a-f\d]{3}-[a-f\d]{12}$/i.test(s.requestId) && Object.keys(fields).every(function (k) {
    return typeof s[k] === "string";
  }) && !Object.values(contactIssues(s)).some(Boolean) && s.email.length <= 254 && s.phone.length <= 32 && intentions.slice(0, 2).includes(s.intencion) && capitals.includes(s.capital) && zones.includes(s.zona) && s.consentVersion === "frq-contact-v1" && !!s.utm && typeof s.utm === "object" && !Array.isArray(s.utm) && Object.entries(s.utm).every(function (_ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return /^utm_(source|medium|campaign|content|term|id)$/.test(key) && typeof value === "string" && value.length <= 200;
  });
}

function LiveContactAgenda(_ref3) {
  var _request$current, _request$current2, _request$current3, _request$current4;

  var answers = _ref3.answers,
      onBack = _ref3.onBack;

  var _useState = (0,react.useState)(empty),
      contact = _useState[0],
      setContact = _useState[1];

  var _useState2 = (0,react.useState)({}),
      errors = _useState2[0],
      setErrors = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      ready = _useState3[0],
      setReady = _useState3[1],
      _useState4 = (0,react.useState)(false),
      busy = _useState4[0],
      setBusy = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      accepted = _useState5[0],
      setAccepted = _useState5[1],
      _useState6 = (0,react.useState)(""),
      message = _useState6[0],
      setMessage = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      calendarReady = _useState7[0],
      setCalendarReady = _useState7[1],
      _useState8 = (0,react.useState)(""),
      preparingText = _useState8[0],
      setPreparingText = _useState8[1];

  var _useState9 = (0,react.useState)(false),
      locked = _useState9[0],
      setLocked = _useState9[1];

  var container = (0,react.useRef)(null),
      submitting = (0,react.useRef)(false),
      mounted = (0,react.useRef)(false);
  var request = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    mounted.current = true;

    try {
      var d = JSON.parse(sessionStorage.getItem(KEY) || "null");

      if ((d === null || d === void 0 ? void 0 : d.version) === 1 && Date.now() - d.savedAt < 86400000 && d.savedAt <= Date.now() && d.contact && Object.keys(fields).every(function (k) {
        return typeof d.contact[k] === "string" && d.contact[k].length <= 254;
      }) && typeof d.contact.consent === "boolean") {
        setContact(d.contact);

        if (restoredRequest(d.request)) {
          request.current = d.request;
          setContact({
            firstname: d.request.firstname,
            lastname: d.request.lastname,
            email: d.request.email,
            phone: d.request.phone,
            consent: true
          });
          setLocked(true);
          setAccepted(d.accepted === true);
          if (!d.accepted) setMessage("Hay un envío pendiente de comprobar. Pulsa verificar para consultar su recepción sin duplicarlo.");
        }
      }
    } catch (_unused) {
      /* Storage may be unavailable or corrupt. */
    }

    setReady(true);
    return function () {
      mounted.current = false;
    };
  }, []);
  (0,react.useEffect)(function () {
    if (!ready) return;

    try {
      sessionStorage.setItem(KEY, JSON.stringify({
        version: 1,
        savedAt: Date.now(),
        contact: contact,
        request: request.current,
        accepted: accepted
      }));
    } catch (_unused2) {}
  }, [ready, contact, busy, accepted]);
  (0,react.useEffect)(function () {
    if (!accepted) return;
    var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var letters = 0;
    setPreparingText(reducedMotion ? PREPARING : "");
    var typing = reducedMotion ? undefined : window.setInterval(function () {
      letters += 1;
      setPreparingText(PREPARING.slice(0, letters));
      if (letters >= PREPARING.length) window.clearInterval(typing);
    }, 22);
    var reveal = window.setTimeout(function () {
      window.clearInterval(typing);
      setCalendarReady(true);
      setMessage("Tu solicitud fue recibida. Elige ahora un horario en el calendario.");
    }, 1500);
    return function () {
      window.clearInterval(typing);
      window.clearTimeout(reveal);
    };
  }, [accepted]);

  var submit = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var issues, first, _container$current, _container$current$qu, e;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!ready || submitting.current || accepted)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              issues = contactIssues(contact);
              setErrors(issues);
              first = Object.keys(issues).find(function (k) {
                return issues[k];
              });

              if (!first) {
                _context.next = 8;
                break;
              }

              (_container$current = container.current) === null || _container$current === void 0 ? void 0 : (_container$current$qu = _container$current.querySelector("#live-" + first)) === null || _container$current$qu === void 0 ? void 0 : _container$current$qu.focus();
              return _context.abrupt("return");

            case 8:
              if (!request.current) {
                request.current = {
                  version: 2,
                  requestId: crypto.randomUUID(),
                  firstname: normalized(contact.firstname),
                  lastname: normalized(contact.lastname),
                  email: contact.email.trim().toLowerCase(),
                  phone: contact.phone.replace(/[\s().-]/g, ""),
                  intencion: answers.intencion,
                  capital: answers.capital,
                  zona: answers.zona,
                  consent: true,
                  consentVersion: "frq-contact-v1",
                  utm: attribution(location.href)
                };
              }

              submitting.current = true; // Persist before the network call so an immediate reload can recover the same request.

              try {
                sessionStorage.setItem(KEY, JSON.stringify({
                  version: 1,
                  savedAt: Date.now(),
                  contact: contact,
                  request: request.current,
                  accepted: false
                }));
              } catch (_unused3) {}

              setBusy(true);
              setLocked(true);
              setMessage("");
              _context.prev = 14;
              _context.next = 17;
              return submitWebLead(request.current);

            case 17:
              if (mounted.current) {
                setAccepted(true);
                setMessage("");
              }

              _context.next = 27;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](14);

              if (mounted.current) {
                _context.next = 24;
                break;
              }

              return _context.abrupt("return");

            case 24:
              e = _context.t0;
              setMessage(e instanceof LeadSubmissionError ? e.message : "No pudimos comprobar la recepción. Pulsa verificar; se usará la misma solicitud para evitar duplicados."); // Only definitive rejection allows editing and a new request. Unknown outcomes keep the original ID.

              if (["invalid_fields", "invalid_consent", "provider_rejected", "integration_disabled", "configuration_required", "origin_not_allowed"].includes(e.code)) {
                request.current = null;
                setLocked(false);
              }

            case 27:
              _context.prev = 27;
              submitting.current = false;
              if (mounted.current) setBusy(false);
              return _context.finish(27);

            case 31:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[14, 20, 27, 31]]);
    }));

    return function submit() {
      return _ref4.apply(this, arguments);
    };
  }();

  var meeting = bookingUrl({
    firstname: ((_request$current = request.current) === null || _request$current === void 0 ? void 0 : _request$current.firstname) || normalized(contact.firstname),
    lastname: ((_request$current2 = request.current) === null || _request$current2 === void 0 ? void 0 : _request$current2.lastname) || normalized(contact.lastname),
    email: ((_request$current3 = request.current) === null || _request$current3 === void 0 ? void 0 : _request$current3.email) || contact.email.trim().toLowerCase()
  });
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    ref: container,
    "aria-busy": busy,
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter" && e.target instanceof HTMLInputElement && e.target.type !== "checkbox") {
        e.preventDefault();
        void submit();
      }
    }
  }, !accepted ? (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "fhelp"
  }, "Env\xEDa tu solicitud para continuar al calendario. La reuni\xF3n se reserva al confirmarla en HubSpot."), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "fields"
  }, Object.keys(fields).map(function (name) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
      className: "fld" + (errors[name] ? " err" : ""),
      key: name
    }, (0,emotion_react_browser_esm/* jsx */.tZ)("label", {
      htmlFor: "live-" + name
    }, fields[name][0]), (0,emotion_react_browser_esm/* jsx */.tZ)("input", {
      id: "live-" + name,
      name: name,
      type: fields[name][2],
      autoComplete: fields[name][1],
      required: true,
      maxLength: name === "email" ? 254 : name === "phone" ? 32 : 100,
      value: contact[name],
      readOnly: locked,
      "aria-invalid": !!errors[name],
      "aria-describedby": errors[name] ? "live-error-" + name : undefined,
      onChange: function onChange(e) {
        var value = LiveContactAgenda_objectSpread(LiveContactAgenda_objectSpread({}, contact), {}, (0,defineProperty/* default */.Z)({}, name, e.target.value));

        setContact(value);
        if (errors[name]) setErrors(function (old) {
          return LiveContactAgenda_objectSpread(LiveContactAgenda_objectSpread({}, old), {}, (0,defineProperty/* default */.Z)({}, name, contactIssues(value)[name]));
        });
      }
    }), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
      className: "msg",
      id: "live-error-" + name
    }, name === "phone" ? "Incluye un teléfono válido con código de país." : name === "email" ? "Escribe un correo válido." : "Completa este campo."));
  })), (0,emotion_react_browser_esm/* jsx */.tZ)("label", {
    className: "consent" + (errors.consent ? " err" : ""),
    htmlFor: "live-consent"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("input", {
    id: "live-consent",
    type: "checkbox",
    required: true,
    checked: contact.consent,
    disabled: locked,
    "aria-invalid": !!errors.consent,
    onChange: function onChange(e) {
      setContact(function (c) {
        return LiveContactAgenda_objectSpread(LiveContactAgenda_objectSpread({}, c), {}, {
          consent: e.target.checked
        });
      });
      setErrors(function (old) {
        return LiveContactAgenda_objectSpread(LiveContactAgenda_objectSpread({}, old), {}, {
          consent: !e.target.checked
        });
      });
    }
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, "S\xED, quiero que REMAX Rep\xFAblica Dominicana me contacte por llamada, WhatsApp o correo para coordinar una reuni\xF3n de presentaci\xF3n sobre la franquicia. ", (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    href: "/politica-privacidad",
    target: "_blank",
    rel: "noreferrer"
  }, "Pol\xEDtica de privacidad"), ".")), errors.consent && (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    role: "alert"
  }, "Confirma tu consentimiento para continuar."), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "fnav"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("button", {
    type: "button",
    className: "back",
    disabled: locked || busy,
    onClick: onBack
  }, "Atr\xE1s"), (0,emotion_react_browser_esm/* jsx */.tZ)("button", {
    type: "button",
    className: "btn btn-1",
    disabled: !ready || busy,
    onClick: function onClick() {
      return void submit();
    }
  }, busy ? "Enviando…" : locked ? "Verificar recepción" : "Enviar y elegir horario"))) : !calendarReady ? (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "fhelp",
    role: "status",
    "aria-label": PREPARING,
    style: {
      minHeight: "3em"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    "aria-hidden": "true"
  }, preparingText)) : (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)("h4", null, "Elige el horario de tu reuni\xF3n"), (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "fhelp"
  }, "Calendario de Melissa Zabala \xB7 30 minutos. La confirmaci\xF3n de la reserva aparecer\xE1 dentro del calendario. Usa el mismo correo de tu solicitud: ", (0,emotion_react_browser_esm/* jsx */.tZ)("strong", null, (_request$current4 = request.current) === null || _request$current4 === void 0 ? void 0 : _request$current4.email), "."), (0,emotion_react_browser_esm/* jsx */.tZ)("iframe", {
    title: "Calendario de reuniones de Melissa Zabala",
    src: meeting,
    className: "frq-meeting",
    referrerPolicy: "no-referrer"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "micro"
  }, "Si el calendario no carga, ", (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    href: meeting,
    target: "_blank",
    rel: "noreferrer"
  }, "abre la agenda en otra pesta\xF1a"), ". Tu solicitud ya est\xE1 registrada; no necesitas enviarla otra vez.")), message && (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    role: "status",
    "aria-live": "polite",
    className: "fhelp"
  }, message));
}
;// CONCATENATED MODULE: ./shared/components-pages/franquicias-landing/FranchiseForm.tsx





function FranchiseForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function FranchiseForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? FranchiseForm_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : FranchiseForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var headings = {
  intro: "Una franquicia REMAX es un negocio propio.",
  p1: "¿Qué estás buscando en REMAX?",
  p2: "¿Con qué capital cuentas para la apertura de tu oficina?",
  p3: "¿En qué zona te gustaría abrir tu oficina?",
  p4: "¿A quién contactamos?",
  p5: "Elige el día y la hora de tu reunión.",
  ok: "Demostración completada.",
  pa: "Buscas algo distinto, y también lo tenemos.",
  pb: "Gracias por tu interés."
};
var contactLabels = {
  nombre: ["Nombre completo", "Nombre y apellido", "Escribe tu nombre y apellido."],
  telefono: ["Teléfono", "809 000 0000", "Escribe un teléfono válido de al menos 10 dígitos."],
  email: ["Correo electrónico", "nombre@correo.com", "Escribe un correo electrónico válido."]
};
var meetingItems = ["El modelo de franquicia completo y cómo opera una oficina REMAX", "Qué incluye el respaldo: marca, tecnología, capacitación, red y acompañamiento", "Las condiciones de inversión con el desglose real, sin estimados", "La disponibilidad de territorio en la zona que seleccionaste"];
function FranchiseForm(_ref) {
  var _ref$live = _ref.live,
      live = _ref$live === void 0 ? false : _ref$live,
      _ref$transport = _ref.transport,
      transport = _ref$transport === void 0 ? demoTransport : _ref$transport,
      _ref$agenda = _ref.agenda,
      agenda = _ref$agenda === void 0 ? demoAgenda : _ref$agenda;

  var _useState = (0,react.useState)("intro"),
      step = _useState[0],
      setStep = _useState[1],
      _useState2 = (0,react.useState)(FranchiseForm_objectSpread({}, emptyAnswers)),
      answers = _useState2[0],
      setAnswers = _useState2[1],
      _useState3 = (0,react.useState)(FranchiseForm_objectSpread({}, emptyAppointment)),
      appointment = _useState3[0],
      setAppointment = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      ready = _useState4[0],
      setReady = _useState4[1],
      _useState5 = (0,react.useState)(false),
      back = _useState5[0],
      setBack = _useState5[1],
      _useState6 = (0,react.useState)([]),
      days = _useState6[0],
      setDays = _useState6[1],
      _useState7 = (0,react.useState)({}),
      errors = _useState7[0],
      setErrors = _useState7[1];

  var _useState8 = (0,react.useState)(""),
      announcement = _useState8[0],
      setAnnouncement = _useState8[1],
      _useState9 = (0,react.useState)("idle"),
      status = _useState9[0],
      setStatus = _useState9[1],
      _useState10 = (0,react.useState)(""),
      failure = _useState10[0],
      setFailure = _useState10[1];

  var _useState11 = (0,react.useState)("https://reclutamiento.remaxrd.com/?utm_source=landing_franquicias&utm_medium=landing&utm_id=campaign_franquicias"),
      recruitment = _useState11[0],
      setRecruitment = _useState11[1];

  var panel = (0,react.useRef)(null),
      form = (0,react.useRef)(null),
      timer = (0,react.useRef)(null),
      pending = (0,react.useRef)(false),
      submitting = (0,react.useRef)(false),
      mounted = (0,react.useRef)(false),
      request = (0,react.useRef)(""),
      focusNext = (0,react.useRef)(false);

  var cancel = function cancel() {
    if (timer.current) clearTimeout(timer.current);
    timer.current = null;
    pending.current = false;
  };

  (0,react.useEffect)(function () {
    mounted.current = true;
    var dates = agenda.days();
    setDays(dates);

    try {
      var draft = restoreDraft(sessionStorage.getItem(live ? "franquicias-live-choices-v1" : DRAFT_KEY));

      if (draft) {
        setAnswers(draft.answers);
        setStep(live && ["p5", "ok"].includes(draft.step) ? "p4" : draft.step);
        setAppointment(draft.appointment.fecha ? draft.appointment : {
          fecha: dates[0],
          hora: ""
        });
      } else setAppointment({
        fecha: dates[0],
        hora: ""
      });
    } catch (_unused) {
      setAppointment({
        fecha: dates[0],
        hora: ""
      });
    }

    var url = new URL(recruitment);
    Object.entries(attribution(location.href)).forEach(function (_ref2) {
      var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 2),
          k = _ref3[0],
          v = _ref3[1];

      return url.searchParams.set("src_" + k, v);
    });
    setRecruitment(url.toString());
    request.current = typeof crypto.randomUUID === "function" ? crypto.randomUUID() : Date.now().toString(36) + "-" + Math.random().toString(36).slice(2);
    setReady(true);
    return function () {
      mounted.current = false;
      cancel();
    }; // The adapters are fixed for the lifetime of this form.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0,react.useEffect)(function () {
    if (!ready || step === "ok") return;

    try {
      sessionStorage.setItem(live ? "franquicias-live-choices-v1" : DRAFT_KEY, JSON.stringify({
        version: 1,
        step: step,
        answers: answers,
        appointment: appointment
      }));
    } catch (_unused2) {
      /* Draft recovery is optional. */
    }
  }, [ready, step, answers, appointment]);
  (0,react.useEffect)(function () {
    var _panel$current, _panel$current2, _panel$current3;

    if (!focusNext.current) return;
    focusNext.current = false;
    (_panel$current = panel.current) === null || _panel$current === void 0 ? void 0 : _panel$current.focus({
      preventScroll: true
    });
    var box = (_panel$current2 = panel.current) === null || _panel$current2 === void 0 ? void 0 : _panel$current2.getBoundingClientRect();
    if (box && (box.top < 90 || box.top > innerHeight * 0.55)) (_panel$current3 = panel.current) === null || _panel$current3 === void 0 ? void 0 : _panel$current3.scrollIntoView({
      block: "start",
      behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth"
    });
  }, [step]);

  var go = function go(next) {
    var isBack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    cancel();
    focusNext.current = true;
    setBack(isBack);
    setStep(next);
    setAnnouncement(headings[next]);
    setFailure("");
  };

  var choose = function choose(name, value) {
    if (pending.current || submitting.current) return;
    setAnswers(function (a) {
      return FranchiseForm_objectSpread(FranchiseForm_objectSpread({}, a), {}, (0,defineProperty/* default */.Z)({}, name, value), name === "intencion" && a.intencion !== value ? {
        capital: "",
        zona: ""
      } : {});
    });
    var next = name === "intencion" ? value === intentions[2] ? "pa" : value === intentions[3] ? "pb" : "p2" : name === "capital" ? "p3" : "p4";
    pending.current = true;
    timer.current = setTimeout(function () {
      return go(next);
    }, 190);
  };

  var checkContact = function checkContact() {
    var e = contactErrors(answers);
    setErrors(e);

    if (Object.values(e).some(Boolean)) {
      var _form$current, _form$current$querySe;

      setAnnouncement("Revisa los campos marcados.");
      var first = Object.keys(e).find(function (k) {
        return e[k];
      });
      (_form$current = form.current) === null || _form$current === void 0 ? void 0 : (_form$current$querySe = _form$current.querySelector("#f-" + first)) === null || _form$current$querySe === void 0 ? void 0 : _form$current$querySe.focus();
      return false;
    }

    return true;
  };

  var confirm = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var lead, result;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!submitting.current) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              if (checkContact()) {
                _context.next = 5;
                break;
              }

              go("p4");
              return _context.abrupt("return");

            case 5:
              if (validAppointment(appointment, agenda.days())) {
                _context.next = 9;
                break;
              }

              setAnnouncement("Elige un día y una hora disponibles para continuar.");
              setFailure("Elige un día y una hora disponibles para continuar.");
              return _context.abrupt("return");

            case 9:
              submitting.current = true;
              setStatus("sending");
              setFailure("");
              _context.prev = 12;
              lead = buildLead(answers, appointment, location.href, request.current);
              _context.next = 16;
              return transport.submit(lead);

            case 16:
              result = _context.sent;

              if (mounted.current) {
                _context.next = 19;
                break;
              }

              return _context.abrupt("return");

            case 19:
              if (!(result.requestId !== lead.requestId || !["demo-complete", "accepted"].includes(result.status))) {
                _context.next = 21;
                break;
              }

              throw new Error("Respuesta no válida");

            case 21:
              setStatus(result.status);

              try {
                sessionStorage.removeItem(DRAFT_KEY);
              } catch (_unused3) {}

              go("ok");
              _context.next = 29;
              break;

            case 26:
              _context.prev = 26;
              _context.t0 = _context["catch"](12);

              if (mounted.current) {
                setStatus("error");
                setFailure("No se pudo completar la solicitud. Tus respuestas siguen aquí; vuelve a intentarlo.");
              }

            case 29:
              _context.prev = 29;
              submitting.current = false;
              return _context.finish(29);

            case 32:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[12, 26, 29, 32]]);
    }));

    return function confirm() {
      return _ref4.apply(this, arguments);
    };
  }();

  var next = function next() {
    if (step === "intro") go("p1");else if (step === "p4" && !live) {
      if (checkContact()) go("p5");
    } else if (step === "p5") void confirm();
  };

  var backButton = (0,emotion_react_browser_esm/* jsx */.tZ)("button", {
    type: "button",
    className: "back",
    disabled: status === "sending",
    onClick: function onClick() {
      return go(previous(step), true);
    }
  }, step === "pa" ? "Volver" : step === "pb" ? "Volver y cambiar mi respuesta" : "Atrás");

  var group = step === "p1" ? {
    name: "intencion",
    items: intentions
  } : step === "p2" ? {
    name: "capital",
    items: capitals
  } : step === "p3" ? {
    name: "zona",
    items: zones
  } : null;
  var progress = ["intro", "p1", "p2", "p3", "p4", "p5"].indexOf(step);
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "prog",
    role: "presentation"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("i", {
    id: "prog",
    style: {
      width: (progress < 0 ? 100 : progress * 20) + "%"
    }
  })), (0,emotion_react_browser_esm/* jsx */.tZ)("form", {
    id: "frq",
    className: "card-body",
    noValidate: true,
    autoComplete: "on",
    ref: form,
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      next();
    },
    "aria-busy": status === "sending"
  }, !live && (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "demo-note"
  }, "Modo demostraci\xF3n: usa datos de prueba. No se enviar\xE1n datos ni se reservar\xE1 una reuni\xF3n."), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "sr",
    role: "status",
    "aria-live": "polite"
  }, announcement), (0,emotion_react_browser_esm/* jsx */.tZ)("section", {
    className: "fstep act" + (back ? " back" : "") + (step === "ok" || step === "pa" || step === "pb" ? " done" : ""),
    "data-step": step,
    tabIndex: -1,
    ref: panel,
    key: step,
    "aria-labelledby": "form-heading"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "fmeta"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, step === "intro" ? "Solicitud de reunión" : step === "p5" ? "Último paso" : group || step === "p4" ? (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, "Pregunta", " ", (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "qn"
  }, step.slice(1).padStart(2, "0")), " ", "de 4") : step === "pa" ? "Otro camino" : step === "pb" ? "Con calma" : "Demostración"), (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, step === "intro" ? "1 min" : step === "p5" ? "Agenda" : step === "p1" ? "Intención" : step === "p2" ? "Inversión" : step === "p3" ? "Territorio" : step === "p4" ? "Contacto" : "")), (0,emotion_react_browser_esm/* jsx */.tZ)("h3", {
    className: "fq",
    id: "form-heading"
  }, step === "ok" && status === "accepted" ? "Recibimos tu solicitud." : headings[step]), step === "intro" && (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "fhelp"
  }, "Diriges tu oficina, formas tu equipo y construyes un activo que te pertenece. No es una vacante de agente inmobiliario. Responde cuatro preguntas y elige el d\xEDa de tu reuni\xF3n de presentaci\xF3n."), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "fnav"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("button", {
    type: "submit",
    disabled: !ready,
    className: "btn btn-1 btn-block"
  }, "Empezar ", (0,emotion_react_browser_esm/* jsx */.tZ)(Arrow, null))), (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "micro",
    style: {
      marginTop: "var(--s4)"
    }
  }, "La apertura de una franquicia requiere una inversi\xF3n inicial.")), group && (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, step === "p2" && (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "fhelp"
  }, "Ninguna respuesta te descarta. Nos sirve para preparar una presentaci\xF3n ajustada a tu situaci\xF3n."), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "opts",
    role: "radiogroup",
    "aria-labelledby": "form-heading"
  }, group.items.map(function (value) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)("label", {
      className: "opt",
      key: value
    }, (0,emotion_react_browser_esm/* jsx */.tZ)("input", {
      type: "radio",
      name: group.name,
      value: value,
      checked: answers[group.name] === value,
      onChange: function onChange() {},
      onClick: function onClick() {
        return choose(group.name, value);
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === "Enter") {
          e.preventDefault();
          choose(group.name, value);
        }
      }
    }), (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, value));
  })), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "fnav"
  }, backButton)), step === "p4" && live && (0,emotion_react_browser_esm/* jsx */.tZ)(LiveContactAgenda, {
    answers: answers,
    onBack: function onBack() {
      return go("p3", true);
    }
  }), step === "p4" && !live && (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "fhelp"
  }, "Un representante de REMAX Rep\xFAblica Dominicana te contactar\xE1 para confirmar tu reuni\xF3n de presentaci\xF3n."), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "fields"
  }, Object.keys(contactLabels).map(function (name) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
      className: "fld" + (errors[name] ? " err" : ""),
      "data-fld": name,
      key: name
    }, (0,emotion_react_browser_esm/* jsx */.tZ)("label", {
      htmlFor: "f-" + name
    }, contactLabels[name][0]), (0,emotion_react_browser_esm/* jsx */.tZ)("input", {
      id: "f-" + name,
      name: name,
      type: name === "email" ? "email" : name === "telefono" ? "tel" : "text",
      inputMode: name === "telefono" ? "tel" : name === "email" ? "email" : "text",
      autoComplete: name === "nombre" ? "name" : name === "telefono" ? "tel" : "email",
      placeholder: contactLabels[name][1],
      value: answers[name],
      maxLength: name === "telefono" ? 40 : 254,
      required: true,
      "aria-invalid": !!errors[name],
      "aria-describedby": errors[name] ? "e-" + name : undefined,
      onChange: function onChange(e) {
        var updated = FranchiseForm_objectSpread(FranchiseForm_objectSpread({}, answers), {}, (0,defineProperty/* default */.Z)({}, name, e.target.value));

        setAnswers(updated);
        if (errors[name]) setErrors(function (old) {
          return FranchiseForm_objectSpread(FranchiseForm_objectSpread({}, old), {}, (0,defineProperty/* default */.Z)({}, name, contactErrors(updated)[name]));
        });
      },
      onBlur: function onBlur() {
        if (errors[name]) setErrors(function (old) {
          return FranchiseForm_objectSpread(FranchiseForm_objectSpread({}, old), {}, (0,defineProperty/* default */.Z)({}, name, contactErrors(answers)[name]));
        });
      }
    }), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
      className: "msg",
      id: "e-" + name
    }, contactLabels[name][2]));
  })), (0,emotion_react_browser_esm/* jsx */.tZ)("label", {
    className: "consent" + (errors.consent ? " err" : ""),
    htmlFor: "f-consent"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("input", {
    id: "f-consent",
    name: "consent",
    type: "checkbox",
    required: true,
    checked: answers.consent,
    "aria-invalid": !!errors.consent,
    "aria-describedby": errors.consent ? "e-consent" : undefined,
    onChange: function onChange(e) {
      setAnswers(FranchiseForm_objectSpread(FranchiseForm_objectSpread({}, answers), {}, {
        consent: e.target.checked
      }));
      setErrors(FranchiseForm_objectSpread(FranchiseForm_objectSpread({}, errors), {}, {
        consent: !e.target.checked
      }));
    }
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, "S\xED, quiero que REMAX Rep\xFAblica Dominicana me contacte por llamada, WhatsApp o correo para coordinar una reuni\xF3n de presentaci\xF3n sobre la franquicia.", " ", (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    href: "/politica-privacidad",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Pol\xEDtica de privacidad"), ".")), errors.consent && (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "submit-error",
    id: "e-consent"
  }, "Debes autorizar el contacto para continuar."), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "fnav"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("button", {
    type: "submit",
    className: "btn btn-1"
  }, "Elegir d\xEDa y hora ", (0,emotion_react_browser_esm/* jsx */.tZ)(Arrow, null)), backButton)), step === "p5" && (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "fhelp"
  }, "Reuni\xF3n de presentaci\xF3n de 45 minutos, presencial o por videollamada. Puedes reprogramarla si lo necesitas."), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "hs-slot",
    "data-placeholder": "true"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "cal-hd"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "m"
  }, appointment.fecha ? dateLabel(appointment.fecha, {
    month: "long",
    year: "numeric"
  }) : ""), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "micro"
  }, "Zona horaria: Santo Domingo (GMT-4)")), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "days",
    role: "group",
    "aria-label": "Elige un d\xEDa"
  }, days.map(function (date) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)("button", {
      type: "button",
      className: "day",
      key: date,
      disabled: status === "sending",
      "aria-pressed": appointment.fecha === date,
      "aria-label": dateLabel(date),
      onClick: function onClick() {
        setAppointment({
          fecha: date,
          hora: ""
        });
        setFailure("");
        setAnnouncement("Día seleccionado: " + dateLabel(date) + ". Elige una hora.");
      }
    }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
      className: "dw"
    }, dateLabel(date, {
      weekday: "short"
    })), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
      className: "dn"
    }, Number(date.slice(-2))));
  })), (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "fmeta",
    style: {
      marginBottom: "var(--s3)"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, "Horarios disponibles")), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "slots",
    role: "group",
    "aria-label": "Elige una hora"
  }, hours.map(function (hour) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)("button", {
      type: "button",
      className: "slot",
      key: hour,
      disabled: status === "sending" || !appointment.fecha || !agenda.available(appointment.fecha, hour),
      "aria-pressed": appointment.hora === hour,
      onClick: function onClick() {
        setAppointment(FranchiseForm_objectSpread(FranchiseForm_objectSpread({}, appointment), {}, {
          hora: hour
        }));
        setFailure("");
        setAnnouncement("Hora seleccionada: " + hour);
      }
    }, hour);
  })), (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "hs-note"
  }, "Vista previa del calendario. Los horarios son simulados y no representan disponibilidad real.")), failure && (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "submit-error",
    role: "alert"
  }, failure), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "fnav"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("button", {
    type: "submit",
    className: "btn btn-1",
    disabled: status === "sending"
  }, status === "sending" ? "Completando…" : "Confirmar mi reunión", " ", (0,emotion_react_browser_esm/* jsx */.tZ)(Arrow, null)), backButton)), step === "ok" && (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "tick"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("svg", {
    viewBox: "0 0 24 24",
    "aria-hidden": "true"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M4 12.6 9.2 18 20 6.6",
    strokeLinecap: "square"
  }))), (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "fhelp"
  }, status === "accepted" ? "Tu solicitud fue recibida. La reunión queda pendiente de confirmación." : "No se enviaron datos ni se reservó una reunión. Has completado el recorrido de prueba."), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "appt"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "k"
  }, status === "accepted" ? "Horario solicitado" : "Horario de ejemplo"), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "v"
  }, dateLabel(appointment.fecha), " \xB7 ", appointment.hora)), (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "fmeta"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, "Qu\xE9 vas a ver en la reuni\xF3n")), (0,emotion_react_browser_esm/* jsx */.tZ)("ul", {
    className: "next"
  }, meetingItems.map(function (item) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)("li", {
      key: item
    }, item);
  }))), step === "pa" && (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "fhelp"
  }, "Lo que se solicita aqu\xED es informaci\xF3n sobre adquirir una franquicia, es decir, ser due\xF1o de una oficina REMAX. Si lo que te interesa es desarrollarte como agente inmobiliario dentro de una oficina, ese es otro camino y tambi\xE9n est\xE1 abierto."), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "fnav"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    className: "btn btn-1",
    href: recruitment,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Ir al proceso para agentes ", (0,emotion_react_browser_esm/* jsx */.tZ)(Arrow, null)), backButton)), step === "pb" && (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "fhelp"
  }, "Por tu respuesta entendemos que por ahora est\xE1s conociendo el modelo, y est\xE1 bien: informarse primero es la manera correcta de empezar. Abrir una franquicia es una decisi\xF3n de negocio que conviene tomar con calma y con la informaci\xF3n completa."), (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "fmeta",
    style: {
      marginTop: "var(--s5)"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, "Sigue conociendo el modelo")), (0,emotion_react_browser_esm/* jsx */.tZ)("ul", {
    className: "next"
  }, [["modelo", "En qué se diferencia ser dueño de oficina de ser agente"], ["respaldo", "Qué respalda a la red y con qué cifras opera"], ["incluye", "Qué recibes exactamente el día que abres"], ["camino", "Los cuatro pasos entre hoy y tu oficina"]].map(function (_ref5) {
    var _ref6 = (0,slicedToArray/* default */.Z)(_ref5, 2),
        id = _ref6[0],
        text = _ref6[1];

    return (0,emotion_react_browser_esm/* jsx */.tZ)("li", {
      key: id
    }, (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
      href: "#" + id,
      style: {
        color: "var(--azul-cl)",
        fontWeight: 700
      },
      onClick: function onClick() {
        return go("intro");
      }
    }, text));
  })), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "fnav"
  }, backButton)))));
}

function Arrow() {
  return (0,emotion_react_browser_esm/* jsx */.tZ)("svg", {
    className: "arrow",
    width: "20",
    height: "14",
    viewBox: "0 0 20 14",
    fill: "none",
    "aria-hidden": "true"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M1 7h17M12 1l6 6-6 6",
    stroke: "currentColor",
    strokeWidth: "2.4",
    strokeLinecap: "square"
  }));
}
;// CONCATENATED MODULE: ./shared/components-pages/franquicias-landing/DirectCalendar.tsx



function DirectCalendar() {
  var url = bookingUrl();
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, (0,emotion_react_browser_esm/* jsx */.tZ)("h3", null, "Agenda tu reuni\xF3n"), (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "fhelp"
  }, "Si ya llenaste el formulario para obtener m\xE1s informaci\xF3n sobre las franquicias y a\xFAn no has agendado una reuni\xF3n, elige aqu\xED el d\xEDa y la hora que m\xE1s te convengan."), (0,emotion_react_browser_esm/* jsx */.tZ)("iframe", {
    title: "Calendario de reuniones de Melissa Zabala",
    src: url,
    className: "frq-meeting",
    loading: "lazy",
    referrerPolicy: "no-referrer"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "micro"
  }, "Si el calendario no carga, ", (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    href: url,
    target: "_blank",
    rel: "noreferrer"
  }, "\xE1brelo en otra pesta\xF1a"), "."));
}
;// CONCATENATED MODULE: ./shared/components-pages/franquicias-landing/effects.js
// Visual effects retained from the supplied design; all resources belong to this mount.
function initializeEffects(root) {
  var disposers = [],
      frames = new Set(),
      timers = new Set();
  var active = true;

  var addEventListener = function addEventListener(type, handler, options) {
    window.addEventListener(type, handler, options);
    disposers.push(function () {
      return window.removeEventListener(type, handler, options);
    });
  };

  var requestAnimationFrame = function requestAnimationFrame(callback) {
    if (!active) return 0;
    var id = window.requestAnimationFrame(function (time) {
      frames["delete"](id);
      if (active) callback(time);
    });
    frames.add(id);
    return id;
  };

  var setTimeout = function setTimeout(callback, delay) {
    if (!active) return 0;
    var id = window.setTimeout(function () {
      timers["delete"](id);
      if (active) callback();
    }, delay);
    timers.add(id);
    return id;
  };

  var IntersectionObserver = function IntersectionObserver(callback, options) {
    var observer = new window.IntersectionObserver(callback, options);
    disposers.push(function () {
      return observer.disconnect();
    });
    return observer;
  };

  "use strict";

  var $ = function $(s, c) {
    return (c || root).querySelector(s);
  };

  var $$ = function $$(s, c) {
    return Array.from((c || root).querySelectorAll(s));
  };

  var RM = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  $("#yr").textContent = new Date().getFullYear();
  /* ── Reveals en scroll ─────────────────────────────────────────
   IntersectionObserver + un barrido de respaldo. El barrido existe
   porque la carga de Montserrat y de las fotos reacomoda el layout
   después del primer cálculo del observer, y algunos bloques del
   primer viewport se quedaban sin revelar. */

  function show(el) {
    if (el.classList.contains("in")) return;
    var d = parseInt(el.dataset.rvD || 0, 10);
    if (RM || !d) el.classList.add("in");else setTimeout(function () {
      return el.classList.add("in");
    }, d);
  }

  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) {
        show(e.target);
        io.unobserve(e.target);
      }
    });
  }, {
    rootMargin: "0px 0px -10% 0px",
    threshold: 0.08
  });
  $$("[data-rv],[data-rv-clip],[data-rv-ph]").forEach(function (el) {
    return io.observe(el);
  });

  function sweep() {
    $$("[data-rv]:not(.in),[data-rv-clip]:not(.in),[data-rv-ph]:not(.in)").forEach(function (el) {
      // Todo lo que ya está en pantalla o quedó por encima: si el usuario saltó
      // con un ancla, esos bloques nunca dispararon el observer.
      if (el.getBoundingClientRect().top < innerHeight * 0.92) {
        show(el);
        io.unobserve(el);
      }
    });
  }

  function tickAll() {
    sweep();
    sweepFx();
  }

  addEventListener("load", function () {
    tickAll();
    setTimeout(tickAll, 300);
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () {
    return setTimeout(tickAll, 60);
  });
  addEventListener("scroll", tickAll, {
    passive: true
  });
  addEventListener("resize", tickAll, {
    passive: true
  });
  /* ── Trazado SVG ─────────────────────────────────────────────── */

  $$("[data-rv-trace]").forEach(function (svg) {
    var p = $(".path", svg);
    var len = p.getTotalLength();
    p.style.strokeDasharray = len;
    p.style.strokeDashoffset = len;

    svg._go = function () {
      p.style.strokeDashoffset = 0;
      svg.classList.add("in");
    };
  });
  /* ── Contadores ──────────────────────────────────────────────── */

  var nf = new Intl.NumberFormat("es-DO");

  function count(el) {
    var target = parseInt(el.dataset.n, 10);

    if (RM) {
      el.textContent = nf.format(target);
      return;
    }

    var dur = 1500,
        t0 = performance.now();

    var tick = function tick(t) {
      var k = Math.min((t - t0) / dur, 1);
      var e = 1 - Math.pow(2, -10 * k); // easeOutExpo

      el.textContent = nf.format(Math.round(target * (k === 1 ? 1 : e)));
      if (k < 1) requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  }
  /* Contadores y trazado comparten el mismo barrido que los reveals,
   para que no se queden en cero si se llega por un ancla. */


  function sweepFx() {
    $$("[data-count]:not([data-ran])").forEach(function (box) {
      if (box.getBoundingClientRect().top < innerHeight * 0.8) {
        box.dataset.ran = "1";
        $$("[data-n]", box).forEach(count);
      }
    });
    $$("[data-rv-trace]:not(.in)").forEach(function (svg) {
      if (svg.getBoundingClientRect().top < innerHeight * 0.8) svg._go();
    });
  } // Primer barrido: va aquí y no antes, porque sweepFx depende de svg._go y de nf.


  tickAll();
  /* ── Header al pasar el hero ─────────────────────────────────── */

  var hdr = $("#hdr"),
      hero = $(".hero");
  new IntersectionObserver(function (es) {
    hdr.classList.toggle("show", !es[0].isIntersecting);
  }, {
    rootMargin: "-90px 0px 0px 0px"
  }).observe(hero);
  /* ── Recorrido: progreso, dibujo de línea y parallax ───────────
   Todo cuelga de un solo rAF por scroll. Si el usuario pidió menos
   movimiento, no se registra nada: la página queda estática. ── */

  var quieto = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var pw = $("#pathWrap"),
      steps = $$(".step", pw || document);
  var incl = $(".incl");
  var fotos = $$(".ph");
  var ticking = false;

  function onScroll() {
    ticking = false;
    var vh = innerHeight;
    /* Barra roja de "el camino" */

    if (pw) {
      var r = pw.getBoundingClientRect();
      var k = Math.max(0, Math.min(1, (vh * 0.72 - r.top) / r.height));
      pw.style.setProperty("--prog", k * 100 + "%");
      steps.forEach(function (s) {
        s.classList.toggle("on", s.getBoundingClientRect().top < vh * 0.72);
      });
    }
    /* Línea roja que se dibuja en "lo que recibes" */


    if (incl) {
      var _r = incl.getBoundingClientRect();

      var _k = Math.max(0, Math.min(1, (vh * 0.78 - _r.top) / _r.height));

      incl.style.setProperty("--draw", _k * 100 + "%");
    }
    /* Parallax de las fotos: ±14 px sobre su recorrido en pantalla */


    if (!quieto) {
      fotos.forEach(function (ph) {
        var r = ph.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var c = (r.top + r.height / 2 - vh / 2) / vh; // −1 … 1

        ph.style.setProperty("--pj", (c * 14).toFixed(1) + "px");
      });
    }
  }

  addEventListener("scroll", function () {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(onScroll);
    }
  }, {
    passive: true
  });
  addEventListener("resize", onScroll, {
    passive: true
  });
  onScroll();
  /* ── El identificador animado se congela fuera de pantalla ───── */

  var la = $("#laAnim");

  if (la) {
    new IntersectionObserver(function (es) {
      la.classList.toggle("is-off", !es[0].isIntersecting);
    }, {
      rootMargin: "120px"
    }).observe(la);
  }
  /* ── Mapa DR: dibujado por scroll ───────────────────────────── */


  var drPath = $(".dr-map .path");

  if (drPath && !RM) {
    var drawByScroll = function drawByScroll() {
      var r = anchor.getBoundingClientRect();
      var vh = innerHeight; // 0 cuando el elemento entra desde abajo, 1 cuando está en el tercio superior

      var p = Math.max(0, Math.min(1, (vh * 0.9 - r.top) / (vh * 0.75)));
      drPath.style.strokeDashoffset = totalLen * (1 - p);
    };

    var totalLen = 10633;
    var anchor = drPath.closest(".st.wide") || drPath.closest(".dr-map");
    addEventListener("scroll", drawByScroll, {
      passive: true
    });
    drawByScroll();
  }
  /* ── Escalonado de las tarjetas de perfil ─────────────────────
   Se marcan desde JS para que sin JS salgan visibles de una vez.
   Si ya están en pantalla al marcarlas, se muestran sin parpadeo. */


  $$(".prof .p").forEach(function (p, i) {
    p.style.setProperty("--i", i);
    p.setAttribute("data-rv", "");
    if (p.getBoundingClientRect().top < innerHeight * 0.92) show(p);else io.observe(p);
  });
  var details = Array.from(root.querySelectorAll(".faq details"));
  details.forEach(function (item) {
    var toggle = function toggle() {
      if (item.open) details.forEach(function (other) {
        if (other !== item) other.open = false;
      });
    };

    item.addEventListener("toggle", toggle);
    disposers.push(function () {
      return item.removeEventListener("toggle", toggle);
    });
  });
  return function () {
    active = false;
    disposers.forEach(function (dispose) {
      return dispose();
    });
    frames.forEach(window.cancelAnimationFrame);
    timers.forEach(window.clearTimeout);
  };
}
;// CONCATENATED MODULE: ./shared/components-pages/franquicias-landing/LandingContent.tsx






function LandingContent(_ref) {
  var _ref$live = _ref.live,
      live = _ref$live === void 0 ? false : _ref$live;
  var root = (0,react.useRef)(null);
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(null),
      withoutForm = _useState[0],
      setWithoutForm = _useState[1];

  (0,react.useEffect)(function () {
    if (router.isReady) setWithoutForm(new URLSearchParams(window.location.search).get("") === "wof");
  }, [router.isReady, router.asPath]);
  (0,react.useEffect)(function () {
    return root.current ? initializeEffects(root.current) : undefined;
  }, []);
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "franchise-landing",
    lang: "es-DO",
    ref: root
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    className: "skip",
    href: "#reunion"
  }, "Ir directo a solicitar la reuni\xF3n"), (0,emotion_react_browser_esm/* jsx */.tZ)("header", {
    className: "hdr",
    id: "hdr"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "hdr-in"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    className: "logo-dark",
    href: "https://www.remaxrd.com/",
    "aria-label": "REMAX Rep\xFAblica Dominicana \xB7 inicio"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("img", {
    src: "/franquicias/img/logo-remax-neg.webp",
    alt: "REMAX Rep\xFAblica Dominicana",
    width: "1797",
    height: "536",
    decoding: "async"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)("nav", {
    className: "hdr-nav",
    "aria-label": "Navegaci\xF3n principal"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    className: "lnk",
    href: "#modelo"
  }, "El modelo"), (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    className: "lnk",
    href: "#perfil"
  }, "\xBFEs para ti?"), (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    className: "lnk",
    href: "#incluye"
  }, "Qu\xE9 recibes"), (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    className: "lnk",
    href: "#camino"
  }, "El camino"), (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    className: "btn btn-1 btn-sm",
    href: "#reunion"
  }, "Solicita tu reuni\xF3n")))), (0,emotion_react_browser_esm/* jsx */.tZ)("main", {
    id: "top"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("section", {
    className: "hero"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "hero-bg",
    "aria-hidden": "true"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("img", {
    src: "/franquicias/img/hero-bg.webp",
    alt: "",
    width: "2400",
    height: "1350",
    fetchpriority: "high",
    srcSet: "/franquicias/img/hero-bg-480.webp 480w, /franquicias/img/hero-bg-800.webp 800w, /franquicias/img/hero-bg-1200.webp 1200w",
    sizes: "100vw",
    decoding: "async"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "hero-glow",
    "aria-hidden": "true"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "wrap",
    style: {
      position: "relative",
      zIndex: "1"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "hero-top"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "logo-dark"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("img", {
    src: "/franquicias/img/logo-remax-neg.webp",
    alt: "REMAX Rep\xFAblica Dominicana",
    width: "1797",
    height: "536",
    decoding: "async"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "hero-tag"
  }, "Franquicias \xB7 Rep\xFAblica Dominicana")), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "hero-mid"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("h1", {
    className: "sr"
  }, "T\xFA diriges tu propia oficina REMAX. Franquicias REMAX en Rep\xFAblica Dominicana."), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "la-anim",
    id: "laAnim",
    "data-rv-clip": ""
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("svg", {
    className: "la",
    viewBox: "520 338 876 406",
    fill: "currentColor",
    role: "img",
    "aria-label": "T\xFA diriges. REMAX respalda.",
    focusable: "false"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("defs", null, (0,emotion_react_browser_esm/* jsx */.tZ)("clipPath", {
    id: "laBand"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("rect", {
    x: "500",
    y: "425",
    width: "920",
    height: "260"
  }))), (0,emotion_react_browser_esm/* jsx */.tZ)("g", {
    className: "la-icon"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("polygon", {
    points: "674.99 419.24 652.04 419.36 669.55 359.99 692.43 359.99 674.99 419.24"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M622.1,361.91l10.33-.09-.28,34.93c-.11,14.3-11.38,22.62-24.64,22.62-13.34,0-24.55-8.28-24.65-22.62l-.25-34.92h10.48s.32,35.27.32,35.27c.07,8.13,6.55,12.93,14.13,12.99,7.1.06,14.07-4.61,14.16-12.49l.4-35.68Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("polygon", {
    points: "556.21 418.27 545.58 418.4 545.6 370.71 526.97 370.61 526.79 361.71 574.88 361.71 574.68 370.64 556.16 370.67 556.21 418.27"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M610.48,356.31c-1.7,1.36-6.98.88-9.15.4l10.59-10.96,11.05.59-12.49,9.97Z"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)("g", {
    clipPath: "url(#laBand)"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("g", {
    className: "la-w la-w--l"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M573.59,477.76v150.87h-45.26v-150.87h45.26Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M639.24,513.65v114.99h-45.26v-114.99h45.26Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M659.73,539.64c4.14-8.9,9.82-15.7,17.02-20.39,7.2-4.69,15.29-7.03,24.26-7.03,7.47,0,13.9,1.53,19.27,4.59,5.37,3.06,9.48,7.24,12.33,12.54v-51.58h45.26v150.87h-45.26v-15.7c-2.85,5.3-6.97,9.48-12.33,12.54-5.37,3.06-11.79,4.59-19.27,4.59-8.97,0-17.06-2.34-24.26-7.03-7.21-4.69-12.88-11.48-17.02-20.39-4.15-8.9-6.22-19.4-6.22-31.5s2.07-22.6,6.22-31.5ZM728.13,556.87c-3.13-3.4-7.14-5.1-12.03-5.1s-8.9,1.7-12.03,5.1c-3.13,3.4-4.69,8.16-4.69,14.27s1.56,10.88,4.69,14.27c3.12,3.4,7.14,5.1,12.03,5.1s8.9-1.7,12.03-5.1c3.12-3.4,4.69-8.16,4.69-14.27s-1.56-10.87-4.69-14.27Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M908.98,579.09h-72.79c.68,9.92,4.82,14.88,12.44,14.88,4.89,0,8.43-2.24,10.6-6.73h47.91c-1.63,8.16-5.07,15.46-10.3,21.92-5.23,6.46-11.83,11.55-19.78,15.29-7.95,3.74-16.69,5.61-26.2,5.61-11.42,0-21.58-2.38-30.48-7.14-8.9-4.76-15.84-11.59-20.8-20.49-4.96-8.9-7.44-19.33-7.44-31.3s2.48-22.39,7.44-31.3c4.96-8.9,11.89-15.73,20.8-20.49,8.9-4.76,19.06-7.14,30.48-7.14s21.58,2.34,30.48,7.03c8.9,4.69,15.83,11.39,20.8,20.08,4.96,8.7,7.44,18.96,7.44,30.79,0,3.13-.2,6.12-.61,8.97ZM863.71,559.32c0-3.8-1.22-6.69-3.67-8.67-2.45-1.97-5.5-2.96-9.17-2.96-8.02,0-12.71,3.87-14.07,11.62h26.91Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M986.04,518.85c6.66-4.01,13.59-6.01,20.8-6.01v48.32h-12.84c-8.56,0-14.85,1.5-18.86,4.49-4.01,2.99-6.01,8.29-6.01,15.9v47.1h-45.26v-114.99h45.26v21.2c4.62-6.66,10.26-11.99,16.92-16Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M1019.17,539.64c4.14-8.9,9.82-15.7,17.02-20.39,7.2-4.69,15.29-7.03,24.26-7.03,7.47,0,13.93,1.53,19.37,4.59,5.43,3.06,9.58,7.24,12.44,12.54v-15.7h45.06v114.99h-45.06v-15.7c-2.85,5.3-7,9.48-12.44,12.54-5.44,3.06-11.9,4.59-19.37,4.59-8.97,0-17.06-2.34-24.26-7.03-7.21-4.69-12.88-11.48-17.02-20.39-4.15-8.9-6.22-19.4-6.22-31.5s2.07-22.6,6.22-31.5ZM1087.57,556.87c-3.13-3.4-7.14-5.1-12.03-5.1s-8.9,1.7-12.03,5.1c-3.13,3.4-4.69,8.16-4.69,14.27s1.56,10.88,4.69,14.27c3.12,3.4,7.14,5.1,12.03,5.1s8.9-1.7,12.03-5.1c3.13-3.4,4.69-8.16,4.69-14.27s-1.56-10.87-4.69-14.27Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M1180.03,624.76c-8.36-3.53-14.99-8.43-19.88-14.68-4.89-6.25-7.68-13.32-8.36-21.2h43.43c.54,3.4,2,5.91,4.38,7.54,2.38,1.63,5.4,2.45,9.07,2.45,2.31,0,4.14-.51,5.5-1.53,1.36-1.02,2.04-2.27,2.04-3.77,0-2.58-1.43-4.42-4.28-5.5-2.85-1.09-7.68-2.31-14.48-3.67-8.29-1.63-15.12-3.4-20.49-5.3-5.37-1.9-10.06-5.16-14.07-9.79-4.01-4.62-6.01-11.01-6.01-19.16,0-7.07,1.87-13.49,5.61-19.27,3.74-5.78,9.28-10.33,16.62-13.66,7.34-3.33,16.24-5,26.71-5,15.5,0,27.63,3.81,36.39,11.42,8.77,7.61,14.03,17.53,15.8,29.77h-40.16c-.68-3.12-2.11-5.54-4.28-7.24-2.18-1.7-5.1-2.55-8.77-2.55-2.31,0-4.08.44-5.3,1.32-1.22.89-1.83,2.21-1.83,3.98,0,2.31,1.43,4.05,4.28,5.2,2.85,1.16,7.41,2.34,13.66,3.57,8.29,1.63,15.29,3.47,21,5.5s10.67,5.54,14.88,10.5c4.21,4.96,6.32,11.79,6.32,20.49,0,6.8-1.97,12.92-5.91,18.35-3.94,5.44-9.62,9.72-17.02,12.84-7.41,3.13-16.07,4.69-26,4.69-10.88,0-20.49-1.76-28.85-5.3Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M1279.22,623.95c-4.76-4.21-7.14-9.51-7.14-15.9s2.38-11.93,7.14-16.21c4.76-4.28,11.08-6.42,18.96-6.42s14,2.14,18.76,6.42c4.76,4.28,7.14,9.68,7.14,16.21s-2.38,11.69-7.14,15.9c-4.76,4.21-11.01,6.32-18.76,6.32s-14.21-2.11-18.96-6.32Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("g", {
    transform: "translate(616.61 477.76)"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("g", {
    className: "la-breathe"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("circle", {
    className: "la-kick la-dot--r",
    r: "28.03"
  })))), (0,emotion_react_browser_esm/* jsx */.tZ)("g", {
    className: "la-w la-w--g"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("g", {
    transform: "translate(2.09 7.99) scale(0.993033)"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M581.49,496.88c4.19,2.36,7.39,5.58,9.59,9.67v-12.1h34.74v87.08c0,8.28-1.52,15.82-4.56,22.64-3.04,6.81-7.94,12.26-14.7,16.35s-15.43,6.13-26.02,6.13c-14.25,0-25.54-3.33-33.87-9.98-8.33-6.66-13.07-15.7-14.23-27.12h34.27c.94,4.61,4.72,6.92,11.32,6.92,4.09,0,7.28-1.05,9.59-3.14,2.3-2.1,3.46-6.03,3.46-11.79v-10.53c-2.2,4.09-5.4,7.31-9.59,9.67-4.19,2.36-9.17,3.54-14.93,3.54-6.92,0-13.15-1.81-18.71-5.42-5.56-3.62-9.93-8.85-13.13-15.72-3.2-6.86-4.79-14.96-4.79-24.29s1.6-17.42,4.79-24.29c3.2-6.86,7.57-12.1,13.13-15.72,5.55-3.62,11.79-5.42,18.71-5.42,5.76,0,10.74,1.18,14.93,3.54ZM587.47,527.76c-2.41-2.62-5.5-3.93-9.27-3.93s-6.87,1.31-9.27,3.93c-2.41,2.62-3.62,6.29-3.62,11s1.2,8.38,3.62,11c2.41,2.62,5.5,3.93,9.27,3.93s6.86-1.31,9.27-3.93c2.41-2.62,3.62-6.29,3.62-11s-1.21-8.38-3.62-11Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M726.89,544.9h-56.12c.52,7.65,3.72,11.47,9.59,11.47,3.77,0,6.5-1.73,8.17-5.19h36.94c-1.26,6.29-3.91,11.92-7.94,16.9-4.04,4.98-9.12,8.91-15.25,11.79-6.13,2.88-12.86,4.32-20.2,4.32-8.8,0-16.64-1.83-23.5-5.5-6.86-3.67-12.21-8.93-16.03-15.8-3.83-6.86-5.74-14.91-5.74-24.13s1.91-17.26,5.74-24.13c3.82-6.86,9.17-12.13,16.03-15.8,6.86-3.67,14.7-5.5,23.5-5.5s16.64,1.81,23.5,5.42c6.86,3.62,12.21,8.78,16.03,15.48,3.82,6.71,5.74,14.62,5.74,23.74,0,2.41-.16,4.72-.47,6.92ZM692,529.65c0-2.93-.94-5.16-2.83-6.68-1.89-1.52-4.24-2.28-7.07-2.28-6.18,0-9.8,2.99-10.85,8.96h20.75Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M755.58,580.11c-6.44-2.72-11.55-6.5-15.33-11.32-3.77-4.82-5.92-10.27-6.44-16.35h33.48c.42,2.62,1.54,4.56,3.38,5.82,1.83,1.26,4.17,1.89,7,1.89,1.78,0,3.2-.39,4.24-1.18,1.05-.79,1.57-1.75,1.57-2.91,0-1.99-1.1-3.4-3.3-4.24-2.2-.84-5.92-1.78-11.16-2.83-6.39-1.26-11.66-2.62-15.8-4.09-4.14-1.47-7.76-3.98-10.85-7.54-3.09-3.56-4.64-8.49-4.64-14.78,0-5.45,1.44-10.4,4.32-14.85,2.88-4.45,7.15-7.96,12.81-10.53,5.66-2.57,12.52-3.85,20.59-3.85,11.95,0,21.3,2.94,28.06,8.8,6.76,5.87,10.82,13.52,12.18,22.95h-30.97c-.53-2.41-1.63-4.27-3.3-5.58-1.68-1.31-3.93-1.96-6.76-1.96-1.78,0-3.14.34-4.09,1.02-.94.68-1.41,1.7-1.41,3.07,0,1.78,1.1,3.12,3.3,4.01,2.2.89,5.71,1.81,10.53,2.75,6.39,1.26,11.79,2.67,16.19,4.24s8.23,4.27,11.48,8.1c3.25,3.83,4.87,9.09,4.87,15.8,0,5.24-1.52,9.96-4.56,14.15-3.04,4.19-7.42,7.49-13.13,9.9-5.71,2.41-12.39,3.62-20.04,3.62-8.38,0-15.8-1.36-22.24-4.09Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M884.55,553.39v29.71h-13.2c-24.31,0-36.47-12.1-36.47-36.31v-23.26h-11v-29.08h11v-21.38h34.9v21.38h14.46v29.08h-14.46v23.89c0,2.1.5,3.62,1.49,4.56.99.94,2.65,1.42,4.95,1.42h8.33Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M932.81,494.44v88.66h-34.9v-88.66h34.9Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M966.6,578.69c-7.13-3.67-12.71-8.93-16.74-15.8-4.04-6.86-6.05-14.91-6.05-24.13s2.02-17.26,6.05-24.13c4.03-6.86,9.61-12.13,16.74-15.8,7.12-3.67,15.14-5.5,24.05-5.5s16.92,1.83,24.05,5.5c7.12,3.67,12.71,8.94,16.74,15.8,4.03,6.86,6.05,14.91,6.05,24.13s-2.02,17.27-6.05,24.13c-4.04,6.87-9.62,12.13-16.74,15.8-7.13,3.67-15.14,5.5-24.05,5.5s-16.92-1.83-24.05-5.5ZM998.83,550.16c2.2-2.57,3.3-6.37,3.3-11.4s-1.1-8.83-3.3-11.4c-2.2-2.57-4.93-3.85-8.17-3.85s-5.97,1.29-8.17,3.85c-2.2,2.57-3.3,6.37-3.3,11.4s1.07,8.83,3.22,11.4c2.15,2.57,4.9,3.85,8.25,3.85s5.97-1.28,8.17-3.85Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M1134.4,504.03c5.71,6.81,8.57,16.03,8.57,27.67v51.4h-34.74v-47c0-4.19-1.13-7.52-3.38-9.98-2.25-2.46-5.27-3.69-9.04-3.69s-6.92,1.23-9.12,3.69c-2.2,2.46-3.3,5.79-3.3,9.98v47h-34.9v-88.66h34.9v13.52c2.72-4.19,6.37-7.6,10.92-10.22,4.56-2.62,9.98-3.93,16.27-3.93,10.16,0,18.1,3.41,23.81,10.22Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M1158.14,514.48c3.2-6.86,7.57-12.1,13.12-15.72,5.55-3.62,11.79-5.42,18.71-5.42,5.76,0,10.74,1.18,14.93,3.54,4.19,2.36,7.39,5.58,9.59,9.67v-12.1h34.74v88.66h-34.74v-12.1c-2.2,4.09-5.4,7.31-9.59,9.67-4.19,2.36-9.17,3.54-14.93,3.54-6.92,0-13.15-1.81-18.71-5.42-5.56-3.62-9.93-8.85-13.12-15.72-3.2-6.86-4.79-14.96-4.79-24.29s1.6-17.42,4.79-24.29ZM1210.87,527.76c-2.41-2.62-5.5-3.93-9.27-3.93s-6.87,1.31-9.27,3.93c-2.41,2.62-3.62,6.29-3.62,11s1.2,8.38,3.62,11c2.41,2.62,5.5,3.93,9.27,3.93s6.86-1.31,9.27-3.93c2.41-2.62,3.62-6.29,3.62-11s-1.21-8.38-3.62-11Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M1282.16,580.11c-6.45-2.72-11.55-6.5-15.33-11.32-3.77-4.82-5.92-10.27-6.45-16.35h33.48c.42,2.62,1.54,4.56,3.38,5.82,1.83,1.26,4.17,1.89,7,1.89,1.78,0,3.2-.39,4.24-1.18,1.05-.79,1.57-1.75,1.57-2.91,0-1.99-1.1-3.4-3.3-4.24-2.2-.84-5.92-1.78-11.16-2.83-6.39-1.26-11.66-2.62-15.8-4.09-4.14-1.47-7.76-3.98-10.85-7.54-3.09-3.56-4.64-8.49-4.64-14.78,0-5.45,1.44-10.4,4.32-14.85,2.88-4.45,7.15-7.96,12.81-10.53,5.66-2.57,12.52-3.85,20.59-3.85,11.95,0,21.3,2.94,28.06,8.8,6.76,5.87,10.82,13.52,12.18,22.95h-30.97c-.53-2.41-1.63-4.27-3.3-5.58-1.68-1.31-3.93-1.96-6.76-1.96-1.78,0-3.14.34-4.09,1.02-.94.68-1.41,1.7-1.41,3.07,0,1.78,1.1,3.12,3.3,4.01,2.2.89,5.71,1.81,10.53,2.75,6.39,1.26,11.79,2.67,16.19,4.24s8.23,4.27,11.47,8.1c3.25,3.83,4.87,9.09,4.87,15.8,0,5.24-1.52,9.96-4.56,14.15-3.04,4.19-7.42,7.49-13.13,9.9-5.71,2.41-12.39,3.62-20.04,3.62-8.39,0-15.8-1.36-22.24-4.09Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M1358.63,579.48c-3.67-3.25-5.5-7.33-5.5-12.26s1.83-9.2,5.5-12.5c3.67-3.3,8.54-4.95,14.62-4.95s10.79,1.65,14.46,4.95c3.67,3.3,5.5,7.47,5.5,12.5s-1.83,9.01-5.5,12.26c-3.67,3.25-8.49,4.87-14.46,4.87s-10.95-1.62-14.62-4.87Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("g", {
    transform: "translate(915.36 465.89)"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("g", {
    className: "la-breathe"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("circle", {
    className: "la-kick la-dot--b",
    r: "19.82"
  }))))), (0,emotion_react_browser_esm/* jsx */.tZ)("g", {
    className: "la-w la-w--d"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("g", {
    transform: "translate(42.03 35.91) scale(0.933982)"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M1136.27,622.41l13.26-31.94c14.56,7.98,31.1,11.41,47.85,10.12,4.88-.38,8.7-2.98,7.93-5.87-.26-.97-1.86-2.71-2.91-2.89l-14.79-2.55c-18.73-3.24-39.47-3.13-48.02-24.67l-.48,19.83h-81.05c2.46,7.37,8.84,12.01,16.43,13.05,11.28,2.06,22.09-.59,31.12-8.01l25.32,25.53c-8.51,9.01-18.86,14.21-30.47,16.87-24.71,4.49-51.14,1.93-70.8-14.23-13.3-10.93-20.3-26.44-20.63-43.68-.44-22.92,11.43-42.99,32.07-53.45,34.72-17.6,85.45-6.08,96.61,34.99-.16-26.21,20.38-38.03,44.18-41.81,13.19-1.78,26.1-1.16,39.26.85,8.54,1.47,16.41,3.72,24.45,7.58l-13.29,31.95c-12.73-6.7-26.53-9.4-40.69-8.21-5.11.43-9.39,2.73-8.89,5.86.16.99,1.72,2.87,2.78,3.05l17.38,2.98c9.73,1.67,19.38,2.79,28.34,6.67,10.89,4.73,17.68,14.23,18.51,25.99,1.66,23.47-16.98,37.58-38.92,41.54-21.06,3.8-42.3,1.68-62.73-4.42l-11.82-5.11ZM1094.5,561.03c-2.08-10.78-10.57-15.68-19.66-15.47-9.14.33-16.47,6.4-17.9,15.63l37.55-.16Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M950.73,674.09c-24.03,3.3-54.7.1-75.32-13.28l16.11-32.9c13.25,9.11,32.14,13.47,48.1,10.41,12.66-2.71,17.76-12.38,17.11-25.02-15.67,15.91-43.32,14.68-61.15,4.29-18.13-10.57-27.56-28.97-27.34-49.66.23-22.13,12.16-41.36,32.64-50.34,12.65-5.55,26.82-6.5,40.24-2.72,7.4,2.09,12.91,6.35,17.94,12.77l.2-12.86h45.89s-.03,95.06-.03,95.06c0,8.76-1.18,16.82-3.62,24.95-7.02,23.41-27.04,36.04-50.77,39.3ZM936.41,587.63c9.02.37,16.8-4.14,19.52-11.62s1.28-16.69-5.51-21.62c-8.05-5.84-19.43-5.52-27.13.79-6.23,5.1-7.42,13.83-4.5,21.22,2.58,6.52,9.52,10.9,17.62,11.23Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M615.17,622.53c-11.26,12.04-32.13,13.39-47.47,9.17-33.81-9.28-47.02-45.29-38.3-78.05,7.11-26.75,31.71-43.26,59.03-40.78,9.13.58,17.31,3.28,24.55,9.57l.04-49.33,48.32-.03v158.59s-45.88.01-45.88.01l-.29-9.17ZM612.63,582.34c1.66-6.27,1.64-12.72-.05-18.55-2.47-8.52-9.71-13.66-18.02-13.54-8.16.12-15.02,5.23-17.44,13.57-1.75,6.02-1.7,12.68.02,18.73,2.42,8.53,9.62,13.8,18.01,13.65,8.03-.14,15.2-5.25,17.48-13.86Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M778.19,631.66l-48.3.05v-116.93s45.85,0,45.85,0l.21,12.22c10.61-10.72,23.42-14.31,37.76-14.36l-.04,42.81c-7.83-1.14-14.63-1.49-21.2.76-8.65,2.79-13.19,9.51-14.17,18.59l-.1,56.86Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("polygon", {
    points: "719.78 631.65 671.45 631.71 671.45 514.79 719.78 514.78 719.78 631.65"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("polygon", {
    points: "864.41 631.69 816.07 631.69 816.07 514.78 864.4 514.78 864.41 631.69"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M1267.53,594.47c6.94-1.37,12.81,3.31,14.04,9.41,1.31,6.49-2.99,12.77-9.43,14.06-6.23,1.24-12.37-2.69-13.92-8.85s2.13-13.19,9.31-14.62Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("g", {
    transform: "translate(695.61 479.09)"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("g", {
    className: "la-breathe"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("circle", {
    className: "la-kick la-dot--b",
    r: "28.03"
  }))), (0,emotion_react_browser_esm/* jsx */.tZ)("g", {
    transform: "translate(841.44 479.09)"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("g", {
    className: "la-breathe"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("circle", {
    className: "la-kick la-dot--r",
    r: "28.03"
  })))))), (0,emotion_react_browser_esm/* jsx */.tZ)("g", {
    className: "la-tag"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M742.84,710.69l16.22,22.83-14.29.04-9.05-13.64-9,13.62-22.28.09-3.57-8.57h-18.68s-3.34,8.52-3.34,8.52l-12.77-.05,19.4-43.98,12.3-.08,17.68,39.85,13.04-17.99-15.3-21.8,13.91-.11,8.85,12.76,8.71-12.7h13.45s-15.3,21.2-15.3,21.2ZM697.2,715.73l-5.65-13.91-5.62,13.97,11.27-.05Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("polygon", {
    points: "652.68 733.63 652.25 710.66 641.23 728.98 635.59 729.21 624.45 711.33 624.21 733.61 612.76 733.55 612.78 689.49 622.98 689.44 638.51 714.95 653.54 689.61 663.91 689.45 664.04 733.57 652.68 733.63"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M554.12,733.63l-8.02-11.73h-6.86s0,11.7,0,11.7l-12.45-.03v-44.11s24.19.34,24.19.34c7.45.1,13.61,5.45,15.07,11.82,1.73,7.57-1.12,14.66-8.12,18.15l9.45,13.77-13.27.1ZM547.64,712.1c4.19-.1,6.41-3.21,6.29-6.59-.11-3.12-2.46-6.09-6.23-6.12l-8.47-.07v12.98s8.4-.21,8.4-.21Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("polygon", {
    points: "603.88 715.83 584.25 715.89 584.2 723.91 607.26 723.92 607.28 733.59 571.87 733.59 571.88 689.47 606.44 689.47 606.5 699.09 584.24 699.12 584.23 706.51 603.81 706.54 603.88 715.83"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M1046.04,716.8c-1.48,9.35-9.11,16.32-18.43,16.46l-21.52.33v-40.95s21.01.25,21.01.25c12.6.15,20.96,11.14,18.94,23.91ZM1038.67,712.94c-.04-7.74-5.65-13.57-13.09-13.7l-11.89-.21v28.04s12.63-.19,12.63-.19c7.34-.11,12.39-6.34,12.35-13.95Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M804.51,733.69l-8.44-12.09-10.85-.02v11.98s-7.59.05-7.59.05v-41s20.03.22,20.03.22c6.93.07,12.63,4.82,13.87,10.74,1.48,7.04-1.08,13.58-8.3,16.67l9.36,13.24-8.07.21ZM796.88,715.15c5.16-.14,7.7-4.67,7.36-8.81s-3.62-7.06-8.21-7.13l-10.83-.17.09,16.42,11.59-.31Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("polygon", {
    points: "846.3 715.89 826.48 715.93 826.51 727.16 849.61 727.17 849.54 733.59 818.88 733.59 818.89 692.63 848.69 692.6 848.71 699.05 826.47 699.05 826.49 709.59 846.25 709.59 846.3 715.89"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M899.56,721.8l-.08,11.8-7.59-.05v-40.91s19.72.2,19.72.2c8.16.08,14.14,5.97,14.56,13.35.44,7.91-4.81,14.98-13.28,15.23l-13.33.4ZM910.87,715.14c5.02-.14,7.74-4.08,7.65-8.16s-3.1-7.64-7.73-7.73l-11.29-.23.03,16.44,11.34-.32Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M956.92,724.14l-20.54-.12-4.04,9.53-7.85-.03,18.32-40.79,7.57-.05,18.42,40.81-7.9.18-3.97-9.53ZM954.19,717.97l-7.65-17.66-7.63,17.83,15.28-.17Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M1078.93,724.05l-20.56.06-4.04,9.55-7.75-.17,18.36-40.79,7.44-.17,18.51,40.97-8,.07-3.97-9.51ZM1076.28,718.01l-7.63-17.76-7.66,17.9,15.28-.13Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M880.02,731.73c-8.67,4.3-18.59,2.77-26.84-2.15l2.61-6.09c8.93,6.33,22.46,5.52,22.64-.79.04-1.39-1.69-3.95-3.2-4.38l-12.85-3.65c-4.97-1.41-8.32-5.15-8.39-9.98s2.58-9.08,7.38-10.94c7.4-2.86,15.26-2.06,22.7,1.7l-2.42,6.01c-8.85-4.96-20.38-3.65-20.16,2.5.07,1.99,1.94,3.9,3.99,4.48l12.28,3.46c4.49,1.26,7.68,4.64,8.01,8.94.3,3.95-1.33,8.7-5.77,10.9Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("polygon", {
    points: "1001.56 727.14 1001.54 733.59 972.53 733.6 972.54 692.82 980.13 692.57 980.14 727.09 1001.56 727.14"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M1108.16,717.49c4.25-1.43,8.15,1.32,9.33,4.83,1.32,3.94-1.02,8.07-4.86,9.38s-7.64-.76-9.17-4.33c-1.58-3.68.18-8.37,4.7-9.89Z"
  })))), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "hero-body"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "hero-sub",
    "data-rv": "",
    "data-rv-d": "80"
  }, "Tu propia oficina inmobiliaria.", (0,emotion_react_browser_esm/* jsx */.tZ)("br", null), (0,emotion_react_browser_esm/* jsx */.tZ)("em", null, "No una vacante de agente.")), (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "lead",
    "data-rv": "",
    "data-rv-d": "140"
  }, "Formas tu equipo y construyes", " ", (0,emotion_react_browser_esm/* jsx */.tZ)("em", {
    className: "acc"
  }, "un activo tuyo"), ", con el respaldo de una estructura que ya opera en m\xE1s de 140 pa\xEDses."), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "hero-cta",
    "data-rv": "",
    "data-rv-d": "200"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    className: "btn btn-1",
    href: "#reunion"
  }, "Solicita tu reuni\xF3n", (0,emotion_react_browser_esm/* jsx */.tZ)("svg", {
    className: "arrow",
    width: "20",
    height: "14",
    viewBox: "0 0 20 14",
    fill: "none",
    "aria-hidden": "true"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M1 7h17M12 1l6 6-6 6",
    stroke: "currentColor",
    strokeWidth: "2.4",
    strokeLinecap: "square"
  }))), (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    className: "btn btn-2",
    href: "#modelo"
  }, "Conoce el modelo")), (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "micro",
    "data-rv": "",
    "data-rv-d": "260"
  }, "Toma menos de un minuto \xB7 Sin compromiso"), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "hero-badge",
    "data-rv": "",
    "data-rv-d": "340"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("b", null, "+570"), (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, "agentes ya operan bajo la marca REMAX en Rep\xFAblica Dominicana"))), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "hero-scroll",
    "aria-hidden": "true"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, "Desliza"), (0,emotion_react_browser_esm/* jsx */.tZ)("i", null))))), (0,emotion_react_browser_esm/* jsx */.tZ)("section", {
    className: "sec sec-700",
    id: "modelo"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "wrap"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "eyebrow",
    "data-rv": ""
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "bar"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "num"
  }, "01"), " El modelo"), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "split"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, (0,emotion_react_browser_esm/* jsx */.tZ)("h2", {
    className: "d2",
    "data-rv": ""
  }, "Una franquicia no es", (0,emotion_react_browser_esm/* jsx */.tZ)("br", null), (0,emotion_react_browser_esm/* jsx */.tZ)("em", {
    className: "h-acc"
  }, "una vacante de agente."))), (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "lead",
    "data-rv": "",
    "data-rv-d": "80"
  }, "El agente vende propiedades. El due\xF1o de oficina dirige un negocio: define la estructura, forma la cultura y multiplica un equipo. Son dos caminos distintos, y esta p\xE1gina es sobre el segundo."), (0,emotion_react_browser_esm/* jsx */.tZ)("svg", {
    className: "trace",
    viewBox: "0 0 460 120",
    role: "img",
    "aria-label": "Trayectoria: de la duda a la direcci\xF3n",
    "data-rv-trace": ""
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    className: "path",
    d: "M18 96 C 110 96, 120 62, 200 60 C 285 58, 300 26, 442 22",
    stroke: "#FF1200",
    strokeWidth: "3.5",
    fill: "none",
    strokeLinecap: "round"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("circle", {
    className: "pt pt-1",
    cx: "18",
    cy: "96",
    r: "8",
    fill: "#4A5165"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("circle", {
    className: "pt pt-2",
    cx: "200",
    cy: "60",
    r: "8",
    fill: "#0043FF"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("circle", {
    className: "pt pt-3",
    cx: "442",
    cy: "22",
    r: "10",
    fill: "#FF1200"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("text", {
    x: "18",
    y: "118",
    fontFamily: "Montserrat,sans-serif",
    fontSize: "12",
    fontWeight: "800",
    fill: "#4A5165",
    letterSpacing: "1.4"
  }, "DUDA"), (0,emotion_react_browser_esm/* jsx */.tZ)("text", {
    x: "176",
    y: "118",
    fontFamily: "Montserrat,sans-serif",
    fontSize: "12",
    fontWeight: "800",
    fill: "#4A5165",
    letterSpacing: "1.4"
  }, "DECISI\xD3N"), (0,emotion_react_browser_esm/* jsx */.tZ)("text", {
    x: "374",
    y: "118",
    fontFamily: "Montserrat,sans-serif",
    fontSize: "12",
    fontWeight: "800",
    fill: "#000E35",
    letterSpacing: "1.4"
  }, "DIRECCI\xD3N")))), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "vs",
    "data-rv": "",
    "data-rv-d": "80"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "vs-col"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "vs-hd"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "dot"
  }), " Agente inmobiliario"), (0,emotion_react_browser_esm/* jsx */.tZ)("ul", null, (0,emotion_react_browser_esm/* jsx */.tZ)("li", null, "Vende propiedades y ", (0,emotion_react_browser_esm/* jsx */.tZ)("b", null, "genera comisiones por operaci\xF3n")), (0,emotion_react_browser_esm/* jsx */.tZ)("li", null, "Trabaja ", (0,emotion_react_browser_esm/* jsx */.tZ)("b", null, "dentro de una estructura"), " que otro cre\xF3"), (0,emotion_react_browser_esm/* jsx */.tZ)("li", null, "Su resultado depende del tiempo que \xE9l mismo dedica"), (0,emotion_react_browser_esm/* jsx */.tZ)("li", null, "Se desarrolla dentro de una oficina existente"))), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "vs-col own"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "vs-hd"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "dot"
  }), " Due\xF1o de oficina"), (0,emotion_react_browser_esm/* jsx */.tZ)("ul", null, (0,emotion_react_browser_esm/* jsx */.tZ)("li", null, "Dirige el negocio y", " ", (0,emotion_react_browser_esm/* jsx */.tZ)("b", null, "construye un activo que le pertenece")), (0,emotion_react_browser_esm/* jsx */.tZ)("li", null, (0,emotion_react_browser_esm/* jsx */.tZ)("b", null, "Crea la estructura"), " y define la cultura de su oficina"), (0,emotion_react_browser_esm/* jsx */.tZ)("li", null, "Su resultado crece con el equipo que recluta y multiplica"), (0,emotion_react_browser_esm/* jsx */.tZ)("li", null, "Opera un territorio con una marca ya establecida")))), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "split",
    style: {
      marginTop: "clamp(48px,7vw,88px)",
      alignItems: "center"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "quote",
    "data-rv": ""
  }, "No necesitas vender cada propiedad.", (0,emotion_react_browser_esm/* jsx */.tZ)("br", null), (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, "Necesitas liderar el negocio.")), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "ph",
    "data-rv-ph": "",
    style: {
      aspectRatio: "4/5"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("img", {
    src: "/franquicias/img/modelo.webp",
    alt: "Profesional de pie en su oficina, dirigiendo su propio negocio",
    width: "1200",
    height: "1500",
    loading: "lazy",
    srcSet: "/franquicias/img/modelo-480.webp 480w, /franquicias/img/modelo-800.webp 800w, /franquicias/img/modelo-1200.webp 1200w",
    sizes: "(max-width: 760px) 100vw, 50vw",
    decoding: "async"
  }))))), (0,emotion_react_browser_esm/* jsx */.tZ)("section", {
    className: "sec light",
    id: "respaldo"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "wrap"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "eyebrow",
    "data-rv": ""
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "bar"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "num"
  }, "02"), " El respaldo"), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "split"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("h2", {
    className: "d2",
    "data-rv": ""
  }, "No compras un logo.", (0,emotion_react_browser_esm/* jsx */.tZ)("br", null), (0,emotion_react_browser_esm/* jsx */.tZ)("em", {
    className: "h-acc"
  }, "Accedes a una estructura", " ", (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "acc"
  }, "que ya opera"), ".")), (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "lead",
    "data-rv": "",
    "data-rv-d": "80"
  }, "Marca, tecnolog\xEDa, capacitaci\xF3n, red y acompa\xF1amiento regional. Todo eso existe antes de que abras y sigue funcionando despu\xE9s.")), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "stats",
    "data-count": ""
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "st"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "n"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "plus"
  }, "+"), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    "data-n": "50"
  }, "50")), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "lb"
  }, "A\xF1os de trayectoria")), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "st"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "n"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "plus"
  }, "+"), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    "data-n": "140"
  }, "140")), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "lb"
  }, "Pa\xEDses con presencia")), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "st"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "n"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "plus"
  }, "+"), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    "data-n": "9000"
  }, "9,000")), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "lb"
  }, "Oficinas en la red")), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "st"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "n"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "plus"
  }, "+"), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    "data-n": "145000"
  }, "145,000")), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "lb"
  }, "Agentes en el mundo")), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "st wide"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("svg", {
    className: "dr-map",
    viewBox: "180 0 1650 1060",
    "aria-hidden": "true",
    focusable: "false"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("defs", null, (0,emotion_react_browser_esm/* jsx */.tZ)("linearGradient", {
    id: "dr-grad",
    gradientUnits: "userSpaceOnUse",
    x1: "180",
    y1: "530",
    x2: "1830",
    y2: "530"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("stop", {
    offset: "0%",
    stopColor: "#ff1200"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("stop", {
    offset: "50%",
    stopColor: "#cc44ff"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("stop", {
    offset: "100%",
    stopColor: "#5b84ff"
  }))), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    className: "map-fill",
    d: "M640.84,25.87c21.42,0,43.1,11.26,59.6,21.06c8.03,4.77,16.14,10.15,23.98,15.35 c28.75,19.08,58.48,38.81,96.97,38.81c13.07-0.09,25.8-2.23,38.18-6.44c4.46,1.59,14.95,8.7,24.59,18.55 c30.95,31.63,62.64,47.01,96.88,47.01c21.07,0,42.8-5.73,66.43-17.52c5.36-2.81,11.06-4.28,17.11-4.4 c16.51,0,28.61,13.72,30.11,34.16c1.98,26.98,6.67,51.01,13.92,71.42c18.25,51.35,45.44,74.26,88.16,74.26 c13.76,0,29.52-2.46,48.19-7.54c18.52-5.04,38.74-5.71,60.14-6.43c5.67-0.19,11.55-0.39,17.34-0.67c3.93-0.19,7.99-0.33,11.91-0.46 c18-0.61,36.53-1.24,55.11-7.07l8.09,5.29l12.65,8.27c-2.51,5.42-5.6,9.33-9.35,11.85c-4.86,3.28-11.68,4.81-21.44,4.81 c-7.03,0-14.62-0.77-22.67-1.57c-8.54-0.86-17.38-1.74-26.15-1.74c-3.09,0-5.94,0.1-8.73,0.32c-0.56,0.05-1.15,0.07-1.74,0.07 c-5.22,0-11.54-1.62-18.22-3.35c-5.57-1.54-11.2-2.77-16.91-3.69c-13.47-1.98-22.39-2.83-29.8-2.83c-9.39,0-23.01,1.21-32.94,11.7 c-12.95,13.67-12.79,35.78-11.14,65.52c0.06,1.04,0.2,2.06,0.44,3.06c0.24,1.01,0.57,1.98,0.98,2.94c0.41,0.95,0.91,1.85,1.49,2.71 c0.57,0.86,1.22,1.66,1.94,2.41c0.72,0.74,1.51,1.42,2.34,2.02c0.84,0.6,1.73,1.13,2.67,1.57c0.94,0.45,1.91,0.8,2.9,1.08 c1,0.27,2.02,0.45,3.05,0.54c2.41,0.21,5.14,0.65,8.04,1.1c5.62,1.03,11.29,1.6,17.01,1.73c3.12,0.02,6.23-0.25,9.31-0.8 c6.82-1.23,13.7-1.84,20.62-1.84c27.04,0,53.1,8.87,80.69,18.26c29.04,9.88,59.07,20.1,91.83,20.1c2.49,0,5.01-0.06,7.47-0.18 c1.97,0.52,3.9,1.17,5.79,1.95c4.84,1.85,10.34,3.93,16.61,3.93c3.53,0.03,6.91-0.67,10.15-2.09 c16.06-7.11,30.99-10.57,45.66-10.57c41.88,0,76.15,29.28,112.44,60.28c2.99,2.55,5.98,5.1,8.97,7.64 c36.11,30.61,71.66,60.26,109.55,86.57c7.71,5.35,12.27,10.2,13.17,14.02c0.84,3.56-0.96,9.08-5.36,16.41 c-5.65,9.4-10.61,19.2-15.41,28.68c-8.93,17.65-17.36,34.32-29.16,46.74c-3.19,3.35-17.49,4.76-27.94,5.78 c-5.77,0.57-12.07,1.18-18.53,2.14c-1.31-0.31-2.65-0.46-4-0.46c-7.28,0-12.81,3.82-16.45,11.33c-0.27,0.56-0.52,1.14-0.72,1.72 c-0.12,0.22-0.26,0.44-0.39,0.65c-8.57,13.68-17.4,27.54-25.96,40.99c-0.76-0.58-1.52-1.15-2.27-1.72 c-11.83-8.95-22.99-17.41-28.53-27.22c-19.32-34.31-45.69-49.61-85.48-49.62c-4.85,0-9.9,0.22-15.44,0.66 c-2.71,0.22-5.58,0.33-8.52,0.33c-14.16,0-28.84-2.46-44.37-5.06c-9.14-1.53-18.59-3.1-28.08-4.18c-3.63-0.41-7.4-1.01-11.38-1.65 c-8.06-1.29-16.4-2.61-25.1-2.61c-3.91-0.02-7.79,0.28-11.64,0.91c-30.83,5.08-63.6,10.05-95.51,10.05 c-33.89,0-63.93-5.7-91.84-17.42c-8.01-3.4-16.27-5.98-24.8-7.73c-8.52-1.74-17.14-2.63-25.83-2.66 c-46.06,0-88.29,24.62-115.84,67.56c-21.56,33.58-44.59,47.91-77.02,47.91c-5.53-0.02-11.03-0.39-16.51-1.1 c-4.85-0.59-9.72-0.89-14.61-0.88c-17.61,0-34.85,3.44-51.52,6.77l-3.08,0.61c-2.15,0.43-4.32,0.66-6.51,0.66 c-1.71,0.03-3.4-0.11-5.08-0.44c-1.68-0.32-3.31-0.81-4.89-1.47c-1.58-0.67-3.07-1.48-4.47-2.45s-2.7-2.08-3.88-3.32 c-5.21-5.48-8.4-13.64-8.98-22.97c-0.85-13.93-6.58-26.64-11.62-37.84c-2.07-4.61-4.03-8.96-5.59-13.18 c-0.4-1.09-0.91-2.13-1.53-3.12c-0.61-0.99-1.32-1.91-2.11-2.76c-0.8-0.85-1.68-1.61-2.62-2.28c-0.95-0.67-1.96-1.24-3.03-1.71 c-1.07-0.47-2.17-0.83-3.31-1.07c-1.14-0.25-2.29-0.38-3.45-0.4c-1.17-0.02-2.32,0.08-3.46,0.3c-1.15,0.22-2.26,0.55-3.34,0.98 c-4.36,1.78-8.76,3.44-13.42,5.2c-10.59,3.99-21.54,8.12-32.1,13.79c-11.65,6.27-23.14,13-34.24,19.51 c-17.89,10.49-34.86,20.44-52.62,28.7c-1.95-0.98-4.59-2.52-6.53-3.66c-6.11-3.57-13.05-7.62-20.67-9.46 c-7.92-2.06-15.97-3.18-24.15-3.34c-9.8,0-17.77,2.35-23.69,6.98c-13.4,10.49-18.8,38.49-10.32,53.51 c9.15,16.18,8.15,26.89,6.6,33.53c-2.23,9.59-8.3,20.28-19.66,34.66c-33.41,42.26-64.36,85.18-97.14,130.62 c-8.81,12.21-17.81,24.7-26.94,37.27c-1.14-1.9-2.28-3.86-3.44-5.84c-12.21-20.89-28.94-49.49-64.28-49.5 c-3.01,0.01-6.01,0.21-8.99,0.6c2.46-36.78-7.52-68.94-31.4-103.45c-11.96-17.29-11.93-48.66-11.9-76.33 c0-5.76,0.01-11.72-0.09-17.43c-0.08-4.57,5.65-13.23,10.26-20.2c3.38-4.92,6.48-10.01,9.33-15.25c0.41-0.79,0.76-1.61,1.05-2.45 s0.51-1.7,0.66-2.58c0.16-0.88,0.24-1.76,0.26-2.65c0.02-0.9-0.03-1.78-0.15-2.67c-0.12-0.88-0.31-1.75-0.56-2.6 c-0.26-0.85-0.57-1.69-0.95-2.49c-0.39-0.81-0.82-1.58-1.32-2.32c-0.5-0.74-1.06-1.43-1.67-2.09c-0.6-0.65-1.26-1.25-1.96-1.8 c-0.7-0.55-1.44-1.05-2.22-1.48c-0.78-0.44-1.58-0.82-2.42-1.13c-0.84-0.31-1.69-0.56-2.56-0.74c-0.88-0.18-1.76-0.3-2.65-0.34 s-1.78-0.02-2.67,0.07c-0.89,0.09-1.77,0.25-2.63,0.47c-0.86,0.22-1.7,0.52-2.52,0.87l-1.38,0.6l-87.54-105.04 c4.17,0.49,8.34,0.74,12.54,0.74c45.59,0,76.28-29.28,91.21-87.02c5.87-22.68,7.14-61.02-37.51-87.65 c8.77-5.76,17.11-12.06,25.04-18.91c32.15-28.49,51.56-45.69,51.5-68.02c-0.05-21.92-18.55-38.15-49.19-65.04 c-0.19-0.17-0.37-0.35-0.54-0.55c43.26-36.53,32.53-81.59,13.68-125.26c-8.17-18.93-8.81-42.92-9.37-64.09 c-0.19-7.25-0.38-14.2-0.83-20.79c10.39-14.8,21.35-25.4,33.39-32.32c5.76-3.29,11.84-5.76,18.27-7.41 c6.42-1.65,12.95-2.42,19.58-2.31c23.08,0,47.93,8.14,78.12,20.35c7.71,3.17,15.66,5.56,23.84,7.19 c8.18,1.63,16.44,2.46,24.78,2.49c28.99,0,57.94-9.6,91.07-30.22c4.89-3.17,10.13-5.58,15.72-7.24c5.59-1.66,11.3-2.49,17.12-2.51 M640.84,8.52c-7.45,0.02-14.74,1.08-21.9,3.18c-7.15,2.1-13.85,5.17-20.12,9.2c-26.31,16.37-53.38,27.6-81.9,27.6 c-7.22-0.02-14.38-0.74-21.46-2.16c-7.08-1.42-13.96-3.5-20.64-6.26c-28.96-11.72-57.48-21.62-84.64-21.62 c-32.07,0-62.26,13.81-89.06,54.74c2.83,26.8-1.3,65.37,12.09,96.4c19.97,46.29,26.58,83.62-21.62,114.39 c5.8,8.01,8.56,13.73,12.96,17.58c57.96,50.86,58.25,53.31-2.38,107.03c-14.04,12.44-30.65,21.98-48.94,34.89 c38.8,13.12,67.29,37.15,56.13,80.31c-11.08,42.83-32.66,74.01-74.4,74.01c-13.1,0-28.2-3.07-45.58-9.82 c0.42,5.14,0.84,10.27,1.26,15.41l114.31,137.16l13.31-5.77c-7.62,14.6-21.8,29.31-21.55,43.77c0.6,35.09-2.81,77.49,15.07,103.33 c25.69,37.11,34.75,71.1,24.65,118.01c11.77-5.38,21.61-7.68,30.03-7.68c37.93,0,46.46,46.72,67.81,67.33 c47.32-64.62,90.61-127.02,137.61-186.47c22.38-28.32,33.96-53.16,14.55-87.48c-4.26-7.52-0.65-26.18,5.91-31.31 c3.09-2.42,7.78-3.3,12.98-3.3c6.8,0.2,13.49,1.16,20.08,2.87c10.92,2.63,23.72,14.35,31.88,14.35c0.95,0.02,1.86-0.17,2.73-0.55 c31.74-14.23,60.97-33.94,91.75-50.48c13.88-7.46,29.2-12.22,43.86-18.21c5.67,15.34,15.21,30.45,16.18,46.08 c1.71,27.69,20,46.94,44.63,46.94c3.33-0.01,6.62-0.34,9.89-0.99c16.76-3.33,34.28-7.05,51.21-7.05c4.16-0.01,8.31,0.23,12.44,0.74 c6.2,0.8,12.43,1.21,18.68,1.23c39.86,0,67.62-18.49,91.64-55.9c24.51-38.18,61.91-59.57,101.22-59.57 c7.55,0.03,15.02,0.8,22.41,2.32c7.39,1.52,14.56,3.76,21.5,6.71c33.16,13.93,65.85,18.78,98.57,18.78 c32.6,0,65.23-4.82,98.33-10.28c2.92-0.47,5.86-0.69,8.82-0.68c11.31,0,23.1,2.85,34.54,4.15c24.8,2.8,49.85,9.34,74.4,9.34 c3.31,0,6.61-0.12,9.9-0.39c4.87-0.39,9.55-0.6,14.05-0.6c30.57,0,52.92,9.83,70.35,40.78c10.6,18.82,33.06,30.95,50.17,46.1 c12.16-19.14,24.4-38.22,36.43-57.44c0.82-1.32,1.56-2.67,2.22-4.07l-0.2,0.04c0.22-0.54,0.5-1.06,0.82-1.55 c-0.15,0.53-0.36,1.03-0.62,1.51c25.67-5.05,52.36-2.43,63.7-14.38c20.45-21.55,31.09-52.2,46.86-78.43 c13.67-22.75,10.25-37.6-12.79-53.6c-37.71-26.19-73.15-55.82-108.23-85.56c-40.98-34.73-80.57-72.04-132.64-72.04 c-16.22,0-33.65,3.61-52.7,12.06c-0.99,0.42-2.03,0.62-3.11,0.6c-6.37,0-15.03-5.89-22.31-5.89c-0.21,0-0.43,0-0.65,0.02 c-2.31,0.11-4.61,0.17-6.91,0.17c-59.8,0-112.7-38.35-172.53-38.35c-7.97-0.02-15.89,0.69-23.74,2.11 c-2.05,0.36-4.11,0.54-6.19,0.52c-7.81,0-15.95-2.1-23.53-2.77c-2.52-45.54,0.5-58.91,26.74-58.91c7.21,0,16.18,1.01,27.28,2.64 c12.62,1.85,25.31,7.23,37.65,7.23c1.04,0,2.07-0.04,3.11-0.11c2.41-0.19,4.86-0.28,7.36-0.27c15.82,0,33.03,3.31,48.83,3.31 c22.94,0,42.95-6.98,51.52-41.2l-39.2-25.62c-22.49,9.21-46.37,8.28-70.14,9.45c-27.18,1.33-55.32,0.66-81.18,7.68 c-16.6,4.52-31.02,6.93-43.63,6.93c-34.95,0-56.11-18.58-71.79-62.7c-7.53-21.2-11.31-44.35-12.96-66.89 c-2.23-30.44-22.34-50.24-47.43-50.24c-4.33,0.06-8.6,0.61-12.8,1.66c-4.2,1.05-8.22,2.58-12.07,4.57 c-20.99,10.47-40.34,15.69-58.68,15.69c-29.98,0-57.25-13.97-84.45-41.78c-9.87-10.09-27.1-24.04-37.51-24.04 c-1.03-0.02-2.03,0.15-3.01,0.47c-11.2,4.06-22.76,6.14-34.67,6.22c-43.15,0-75.46-29.96-112.08-51.72 c-21.17-12.58-44.34-23.49-68.47-23.49V8.52z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    className: "path",
    d: "M640.84,25.87c21.42,0,43.1,11.26,59.6,21.06c8.03,4.77,16.14,10.15,23.98,15.35 c28.75,19.08,58.48,38.81,96.97,38.81c13.07-0.09,25.8-2.23,38.18-6.44c4.46,1.59,14.95,8.7,24.59,18.55 c30.95,31.63,62.64,47.01,96.88,47.01c21.07,0,42.8-5.73,66.43-17.52c5.36-2.81,11.06-4.28,17.11-4.4 c16.51,0,28.61,13.72,30.11,34.16c1.98,26.98,6.67,51.01,13.92,71.42c18.25,51.35,45.44,74.26,88.16,74.26 c13.76,0,29.52-2.46,48.19-7.54c18.52-5.04,38.74-5.71,60.14-6.43c5.67-0.19,11.55-0.39,17.34-0.67c3.93-0.19,7.99-0.33,11.91-0.46 c18-0.61,36.53-1.24,55.11-7.07l8.09,5.29l12.65,8.27c-2.51,5.42-5.6,9.33-9.35,11.85c-4.86,3.28-11.68,4.81-21.44,4.81 c-7.03,0-14.62-0.77-22.67-1.57c-8.54-0.86-17.38-1.74-26.15-1.74c-3.09,0-5.94,0.1-8.73,0.32c-0.56,0.05-1.15,0.07-1.74,0.07 c-5.22,0-11.54-1.62-18.22-3.35c-5.57-1.54-11.2-2.77-16.91-3.69c-13.47-1.98-22.39-2.83-29.8-2.83c-9.39,0-23.01,1.21-32.94,11.7 c-12.95,13.67-12.79,35.78-11.14,65.52c0.06,1.04,0.2,2.06,0.44,3.06c0.24,1.01,0.57,1.98,0.98,2.94c0.41,0.95,0.91,1.85,1.49,2.71 c0.57,0.86,1.22,1.66,1.94,2.41c0.72,0.74,1.51,1.42,2.34,2.02c0.84,0.6,1.73,1.13,2.67,1.57c0.94,0.45,1.91,0.8,2.9,1.08 c1,0.27,2.02,0.45,3.05,0.54c2.41,0.21,5.14,0.65,8.04,1.1c5.62,1.03,11.29,1.6,17.01,1.73c3.12,0.02,6.23-0.25,9.31-0.8 c6.82-1.23,13.7-1.84,20.62-1.84c27.04,0,53.1,8.87,80.69,18.26c29.04,9.88,59.07,20.1,91.83,20.1c2.49,0,5.01-0.06,7.47-0.18 c1.97,0.52,3.9,1.17,5.79,1.95c4.84,1.85,10.34,3.93,16.61,3.93c3.53,0.03,6.91-0.67,10.15-2.09 c16.06-7.11,30.99-10.57,45.66-10.57c41.88,0,76.15,29.28,112.44,60.28c2.99,2.55,5.98,5.1,8.97,7.64 c36.11,30.61,71.66,60.26,109.55,86.57c7.71,5.35,12.27,10.2,13.17,14.02c0.84,3.56-0.96,9.08-5.36,16.41 c-5.65,9.4-10.61,19.2-15.41,28.68c-8.93,17.65-17.36,34.32-29.16,46.74c-3.19,3.35-17.49,4.76-27.94,5.78 c-5.77,0.57-12.07,1.18-18.53,2.14c-1.31-0.31-2.65-0.46-4-0.46c-7.28,0-12.81,3.82-16.45,11.33c-0.27,0.56-0.52,1.14-0.72,1.72 c-0.12,0.22-0.26,0.44-0.39,0.65c-8.57,13.68-17.4,27.54-25.96,40.99c-0.76-0.58-1.52-1.15-2.27-1.72 c-11.83-8.95-22.99-17.41-28.53-27.22c-19.32-34.31-45.69-49.61-85.48-49.62c-4.85,0-9.9,0.22-15.44,0.66 c-2.71,0.22-5.58,0.33-8.52,0.33c-14.16,0-28.84-2.46-44.37-5.06c-9.14-1.53-18.59-3.1-28.08-4.18c-3.63-0.41-7.4-1.01-11.38-1.65 c-8.06-1.29-16.4-2.61-25.1-2.61c-3.91-0.02-7.79,0.28-11.64,0.91c-30.83,5.08-63.6,10.05-95.51,10.05 c-33.89,0-63.93-5.7-91.84-17.42c-8.01-3.4-16.27-5.98-24.8-7.73c-8.52-1.74-17.14-2.63-25.83-2.66 c-46.06,0-88.29,24.62-115.84,67.56c-21.56,33.58-44.59,47.91-77.02,47.91c-5.53-0.02-11.03-0.39-16.51-1.1 c-4.85-0.59-9.72-0.89-14.61-0.88c-17.61,0-34.85,3.44-51.52,6.77l-3.08,0.61c-2.15,0.43-4.32,0.66-6.51,0.66 c-1.71,0.03-3.4-0.11-5.08-0.44c-1.68-0.32-3.31-0.81-4.89-1.47c-1.58-0.67-3.07-1.48-4.47-2.45s-2.7-2.08-3.88-3.32 c-5.21-5.48-8.4-13.64-8.98-22.97c-0.85-13.93-6.58-26.64-11.62-37.84c-2.07-4.61-4.03-8.96-5.59-13.18 c-0.4-1.09-0.91-2.13-1.53-3.12c-0.61-0.99-1.32-1.91-2.11-2.76c-0.8-0.85-1.68-1.61-2.62-2.28c-0.95-0.67-1.96-1.24-3.03-1.71 c-1.07-0.47-2.17-0.83-3.31-1.07c-1.14-0.25-2.29-0.38-3.45-0.4c-1.17-0.02-2.32,0.08-3.46,0.3c-1.15,0.22-2.26,0.55-3.34,0.98 c-4.36,1.78-8.76,3.44-13.42,5.2c-10.59,3.99-21.54,8.12-32.1,13.79c-11.65,6.27-23.14,13-34.24,19.51 c-17.89,10.49-34.86,20.44-52.62,28.7c-1.95-0.98-4.59-2.52-6.53-3.66c-6.11-3.57-13.05-7.62-20.67-9.46 c-7.92-2.06-15.97-3.18-24.15-3.34c-9.8,0-17.77,2.35-23.69,6.98c-13.4,10.49-18.8,38.49-10.32,53.51 c9.15,16.18,8.15,26.89,6.6,33.53c-2.23,9.59-8.3,20.28-19.66,34.66c-33.41,42.26-64.36,85.18-97.14,130.62 c-8.81,12.21-17.81,24.7-26.94,37.27c-1.14-1.9-2.28-3.86-3.44-5.84c-12.21-20.89-28.94-49.49-64.28-49.5 c-3.01,0.01-6.01,0.21-8.99,0.6c2.46-36.78-7.52-68.94-31.4-103.45c-11.96-17.29-11.93-48.66-11.9-76.33 c0-5.76,0.01-11.72-0.09-17.43c-0.08-4.57,5.65-13.23,10.26-20.2c3.38-4.92,6.48-10.01,9.33-15.25c0.41-0.79,0.76-1.61,1.05-2.45 s0.51-1.7,0.66-2.58c0.16-0.88,0.24-1.76,0.26-2.65c0.02-0.9-0.03-1.78-0.15-2.67c-0.12-0.88-0.31-1.75-0.56-2.6 c-0.26-0.85-0.57-1.69-0.95-2.49c-0.39-0.81-0.82-1.58-1.32-2.32c-0.5-0.74-1.06-1.43-1.67-2.09c-0.6-0.65-1.26-1.25-1.96-1.8 c-0.7-0.55-1.44-1.05-2.22-1.48c-0.78-0.44-1.58-0.82-2.42-1.13c-0.84-0.31-1.69-0.56-2.56-0.74c-0.88-0.18-1.76-0.3-2.65-0.34 s-1.78-0.02-2.67,0.07c-0.89,0.09-1.77,0.25-2.63,0.47c-0.86,0.22-1.7,0.52-2.52,0.87l-1.38,0.6l-87.54-105.04 c4.17,0.49,8.34,0.74,12.54,0.74c45.59,0,76.28-29.28,91.21-87.02c5.87-22.68,7.14-61.02-37.51-87.65 c8.77-5.76,17.11-12.06,25.04-18.91c32.15-28.49,51.56-45.69,51.5-68.02c-0.05-21.92-18.55-38.15-49.19-65.04 c-0.19-0.17-0.37-0.35-0.54-0.55c43.26-36.53,32.53-81.59,13.68-125.26c-8.17-18.93-8.81-42.92-9.37-64.09 c-0.19-7.25-0.38-14.2-0.83-20.79c10.39-14.8,21.35-25.4,33.39-32.32c5.76-3.29,11.84-5.76,18.27-7.41 c6.42-1.65,12.95-2.42,19.58-2.31c23.08,0,47.93,8.14,78.12,20.35c7.71,3.17,15.66,5.56,23.84,7.19 c8.18,1.63,16.44,2.46,24.78,2.49c28.99,0,57.94-9.6,91.07-30.22c4.89-3.17,10.13-5.58,15.72-7.24c5.59-1.66,11.3-2.49,17.12-2.51 M640.84,8.52c-7.45,0.02-14.74,1.08-21.9,3.18c-7.15,2.1-13.85,5.17-20.12,9.2c-26.31,16.37-53.38,27.6-81.9,27.6 c-7.22-0.02-14.38-0.74-21.46-2.16c-7.08-1.42-13.96-3.5-20.64-6.26c-28.96-11.72-57.48-21.62-84.64-21.62 c-32.07,0-62.26,13.81-89.06,54.74c2.83,26.8-1.3,65.37,12.09,96.4c19.97,46.29,26.58,83.62-21.62,114.39 c5.8,8.01,8.56,13.73,12.96,17.58c57.96,50.86,58.25,53.31-2.38,107.03c-14.04,12.44-30.65,21.98-48.94,34.89 c38.8,13.12,67.29,37.15,56.13,80.31c-11.08,42.83-32.66,74.01-74.4,74.01c-13.1,0-28.2-3.07-45.58-9.82 c0.42,5.14,0.84,10.27,1.26,15.41l114.31,137.16l13.31-5.77c-7.62,14.6-21.8,29.31-21.55,43.77c0.6,35.09-2.81,77.49,15.07,103.33 c25.69,37.11,34.75,71.1,24.65,118.01c11.77-5.38,21.61-7.68,30.03-7.68c37.93,0,46.46,46.72,67.81,67.33 c47.32-64.62,90.61-127.02,137.61-186.47c22.38-28.32,33.96-53.16,14.55-87.48c-4.26-7.52-0.65-26.18,5.91-31.31 c3.09-2.42,7.78-3.3,12.98-3.3c6.8,0.2,13.49,1.16,20.08,2.87c10.92,2.63,23.72,14.35,31.88,14.35c0.95,0.02,1.86-0.17,2.73-0.55 c31.74-14.23,60.97-33.94,91.75-50.48c13.88-7.46,29.2-12.22,43.86-18.21c5.67,15.34,15.21,30.45,16.18,46.08 c1.71,27.69,20,46.94,44.63,46.94c3.33-0.01,6.62-0.34,9.89-0.99c16.76-3.33,34.28-7.05,51.21-7.05c4.16-0.01,8.31,0.23,12.44,0.74 c6.2,0.8,12.43,1.21,18.68,1.23c39.86,0,67.62-18.49,91.64-55.9c24.51-38.18,61.91-59.57,101.22-59.57 c7.55,0.03,15.02,0.8,22.41,2.32c7.39,1.52,14.56,3.76,21.5,6.71c33.16,13.93,65.85,18.78,98.57,18.78 c32.6,0,65.23-4.82,98.33-10.28c2.92-0.47,5.86-0.69,8.82-0.68c11.31,0,23.1,2.85,34.54,4.15c24.8,2.8,49.85,9.34,74.4,9.34 c3.31,0,6.61-0.12,9.9-0.39c4.87-0.39,9.55-0.6,14.05-0.6c30.57,0,52.92,9.83,70.35,40.78c10.6,18.82,33.06,30.95,50.17,46.1 c12.16-19.14,24.4-38.22,36.43-57.44c0.82-1.32,1.56-2.67,2.22-4.07l-0.2,0.04c0.22-0.54,0.5-1.06,0.82-1.55 c-0.15,0.53-0.36,1.03-0.62,1.51c25.67-5.05,52.36-2.43,63.7-14.38c20.45-21.55,31.09-52.2,46.86-78.43 c13.67-22.75,10.25-37.6-12.79-53.6c-37.71-26.19-73.15-55.82-108.23-85.56c-40.98-34.73-80.57-72.04-132.64-72.04 c-16.22,0-33.65,3.61-52.7,12.06c-0.99,0.42-2.03,0.62-3.11,0.6c-6.37,0-15.03-5.89-22.31-5.89c-0.21,0-0.43,0-0.65,0.02 c-2.31,0.11-4.61,0.17-6.91,0.17c-59.8,0-112.7-38.35-172.53-38.35c-7.97-0.02-15.89,0.69-23.74,2.11 c-2.05,0.36-4.11,0.54-6.19,0.52c-7.81,0-15.95-2.1-23.53-2.77c-2.52-45.54,0.5-58.91,26.74-58.91c7.21,0,16.18,1.01,27.28,2.64 c12.62,1.85,25.31,7.23,37.65,7.23c1.04,0,2.07-0.04,3.11-0.11c2.41-0.19,4.86-0.28,7.36-0.27c15.82,0,33.03,3.31,48.83,3.31 c22.94,0,42.95-6.98,51.52-41.2l-39.2-25.62c-22.49,9.21-46.37,8.28-70.14,9.45c-27.18,1.33-55.32,0.66-81.18,7.68 c-16.6,4.52-31.02,6.93-43.63,6.93c-34.95,0-56.11-18.58-71.79-62.7c-7.53-21.2-11.31-44.35-12.96-66.89 c-2.23-30.44-22.34-50.24-47.43-50.24c-4.33,0.06-8.6,0.61-12.8,1.66c-4.2,1.05-8.22,2.58-12.07,4.57 c-20.99,10.47-40.34,15.69-58.68,15.69c-29.98,0-57.25-13.97-84.45-41.78c-9.87-10.09-27.1-24.04-37.51-24.04 c-1.03-0.02-2.03,0.15-3.01,0.47c-11.2,4.06-22.76,6.14-34.67,6.22c-43.15,0-75.46-29.96-112.08-51.72 c-21.17-12.58-44.34-23.49-68.47-23.49V8.52z"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "wide-data"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "n"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "plus"
  }, "+"), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    "data-n": "570"
  }, "570")), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "lb"
  }, "Agentes en Rep\xFAblica Dominicana")))), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "closer"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("svg", {
    viewBox: "519 345 876 392",
    "aria-label": "T\xFA diriges. REMAX respalda.",
    role: "img",
    "data-rv-clip": "",
    style: {
      width: "min(380px,72vw)",
      height: "auto",
      display: "block"
    },
    fill: "currentColor"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("g", null, (0,emotion_react_browser_esm/* jsx */.tZ)("polygon", {
    points: "674.99 419.24 652.04 419.36 669.55 359.99 692.43 359.99 674.99 419.24"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("g", null, (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M622.1,361.91l10.33-.09-.28,34.93c-.11,14.3-11.38,22.62-24.64,22.62-13.34,0-24.55-8.28-24.65-22.62l-.25-34.92h10.48s.32,35.27.32,35.27c.07,8.13,6.55,12.93,14.13,12.99,7.1.06,14.07-4.61,14.16-12.49l.4-35.68Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("polygon", {
    points: "556.21 418.27 545.58 418.4 545.6 370.71 526.97 370.61 526.79 361.71 574.88 361.71 574.68 370.64 556.16 370.67 556.21 418.27"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M610.48,356.31c-1.7,1.36-6.98.88-9.15.4l10.59-10.96,11.05.59-12.49,9.97Z"
  }))), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M742.84,710.69l16.22,22.83-14.29.04-9.05-13.64-9,13.62-22.28.09-3.57-8.57h-18.68s-3.34,8.52-3.34,8.52l-12.77-.05,19.4-43.98,12.3-.08,17.68,39.85,13.04-17.99-15.3-21.8,13.91-.11,8.85,12.76,8.71-12.7h13.45s-15.3,21.2-15.3,21.2ZM697.2,715.73l-5.65-13.91-5.62,13.97,11.27-.05Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("polygon", {
    points: "652.68 733.63 652.25 710.66 641.23 728.98 635.59 729.21 624.45 711.33 624.21 733.61 612.76 733.55 612.78 689.49 622.98 689.44 638.51 714.95 653.54 689.61 663.91 689.45 664.04 733.57 652.68 733.63"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M554.12,733.63l-8.02-11.73h-6.86s0,11.7,0,11.7l-12.45-.03v-44.11s24.19.34,24.19.34c7.45.1,13.61,5.45,15.07,11.82,1.73,7.57-1.12,14.66-8.12,18.15l9.45,13.77-13.27.1ZM547.64,712.1c4.19-.1,6.41-3.21,6.29-6.59-.11-3.12-2.46-6.09-6.23-6.12l-8.47-.07v12.98s8.4-.21,8.4-.21Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("polygon", {
    points: "603.88 715.83 584.25 715.89 584.2 723.91 607.26 723.92 607.28 733.59 571.87 733.59 571.88 689.47 606.44 689.47 606.5 699.09 584.24 699.12 584.23 706.51 603.81 706.54 603.88 715.83"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M1046.04,716.8c-1.48,9.35-9.11,16.32-18.43,16.46l-21.52.33v-40.95s21.01.25,21.01.25c12.6.15,20.96,11.14,18.94,23.91ZM1038.67,712.94c-.04-7.74-5.65-13.57-13.09-13.7l-11.89-.21v28.04s12.63-.19,12.63-.19c7.34-.11,12.39-6.34,12.35-13.95Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M804.51,733.69l-8.44-12.09-10.85-.02v11.98s-7.59.05-7.59.05v-41s20.03.22,20.03.22c6.93.07,12.63,4.82,13.87,10.74,1.48,7.04-1.08,13.58-8.3,16.67l9.36,13.24-8.07.21ZM796.88,715.15c5.16-.14,7.7-4.67,7.36-8.81s-3.62-7.06-8.21-7.13l-10.83-.17.09,16.42,11.59-.31Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("polygon", {
    points: "846.3 715.89 826.48 715.93 826.51 727.16 849.61 727.17 849.54 733.59 818.88 733.59 818.89 692.63 848.69 692.6 848.71 699.05 826.47 699.05 826.49 709.59 846.25 709.59 846.3 715.89"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M899.56,721.8l-.08,11.8-7.59-.05v-40.91s19.72.2,19.72.2c8.16.08,14.14,5.97,14.56,13.35.44,7.91-4.81,14.98-13.28,15.23l-13.33.4ZM910.87,715.14c5.02-.14,7.74-4.08,7.65-8.16s-3.1-7.64-7.73-7.73l-11.29-.23.03,16.44,11.34-.32Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M956.92,724.14l-20.54-.12-4.04,9.53-7.85-.03,18.32-40.79,7.57-.05,18.42,40.81-7.9.18-3.97-9.53ZM954.19,717.97l-7.65-17.66-7.63,17.83,15.28-.17Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M1078.93,724.05l-20.56.06-4.04,9.55-7.75-.17,18.36-40.79,7.44-.17,18.51,40.97-8,.07-3.97-9.51ZM1076.28,718.01l-7.63-17.76-7.66,17.9,15.28-.13Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M880.02,731.73c-8.67,4.3-18.59,2.77-26.84-2.15l2.61-6.09c8.93,6.33,22.46,5.52,22.64-.79.04-1.39-1.69-3.95-3.2-4.38l-12.85-3.65c-4.97-1.41-8.32-5.15-8.39-9.98s2.58-9.08,7.38-10.94c7.4-2.86,15.26-2.06,22.7,1.7l-2.42,6.01c-8.85-4.96-20.38-3.65-20.16,2.5.07,1.99,1.94,3.9,3.99,4.48l12.28,3.46c4.49,1.26,7.68,4.64,8.01,8.94.3,3.95-1.33,8.7-5.77,10.9Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("polygon", {
    points: "1001.56 727.14 1001.54 733.59 972.53 733.6 972.54 692.82 980.13 692.57 980.14 727.09 1001.56 727.14"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M1108.16,717.49c4.25-1.43,8.15,1.32,9.33,4.83,1.32,3.94-1.02,8.07-4.86,9.38s-7.64-.76-9.17-4.33c-1.58-3.68.18-8.37,4.7-9.89Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M1136.27,622.41l13.26-31.94c14.56,7.98,31.1,11.41,47.85,10.12,4.88-.38,8.7-2.98,7.93-5.87-.26-.97-1.86-2.71-2.91-2.89l-14.79-2.55c-18.73-3.24-39.47-3.13-48.02-24.67l-.48,19.83h-81.05c2.46,7.37,8.84,12.01,16.43,13.05,11.28,2.06,22.09-.59,31.12-8.01l25.32,25.53c-8.51,9.01-18.86,14.21-30.47,16.87-24.71,4.49-51.14,1.93-70.8-14.23-13.3-10.93-20.3-26.44-20.63-43.68-.44-22.92,11.43-42.99,32.07-53.45,34.72-17.6,85.45-6.08,96.61,34.99-.16-26.21,20.38-38.03,44.18-41.81,13.19-1.78,26.1-1.16,39.26.85,8.54,1.47,16.41,3.72,24.45,7.58l-13.29,31.95c-12.73-6.7-26.53-9.4-40.69-8.21-5.11.43-9.39,2.73-8.89,5.86.16.99,1.72,2.87,2.78,3.05l17.38,2.98c9.73,1.67,19.38,2.79,28.34,6.67,10.89,4.73,17.68,14.23,18.51,25.99,1.66,23.47-16.98,37.58-38.92,41.54-21.06,3.8-42.3,1.68-62.73-4.42l-11.82-5.11ZM1094.5,561.03c-2.08-10.78-10.57-15.68-19.66-15.47-9.14.33-16.47,6.4-17.9,15.63l37.55-.16Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M950.73,674.09c-24.03,3.3-54.7.1-75.32-13.28l16.11-32.9c13.25,9.11,32.14,13.47,48.1,10.41,12.66-2.71,17.76-12.38,17.11-25.02-15.67,15.91-43.32,14.68-61.15,4.29-18.13-10.57-27.56-28.97-27.34-49.66.23-22.13,12.16-41.36,32.64-50.34,12.65-5.55,26.82-6.5,40.24-2.72,7.4,2.09,12.91,6.35,17.94,12.77l.2-12.86h45.89s-.03,95.06-.03,95.06c0,8.76-1.18,16.82-3.62,24.95-7.02,23.41-27.04,36.04-50.77,39.3ZM936.41,587.63c9.02.37,16.8-4.14,19.52-11.62s1.28-16.69-5.51-21.62c-8.05-5.84-19.43-5.52-27.13.79-6.23,5.1-7.42,13.83-4.5,21.22,2.58,6.52,9.52,10.9,17.62,11.23Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M615.17,622.53c-11.26,12.04-32.13,13.39-47.47,9.17-33.81-9.28-47.02-45.29-38.3-78.05,7.11-26.75,31.71-43.26,59.03-40.78,9.13.58,17.31,3.28,24.55,9.57l.04-49.33,48.32-.03v158.59s-45.88.01-45.88.01l-.29-9.17ZM612.63,582.34c1.66-6.27,1.64-12.72-.05-18.55-2.47-8.52-9.71-13.66-18.02-13.54-8.16.12-15.02,5.23-17.44,13.57-1.75,6.02-1.7,12.68.02,18.73,2.42,8.53,9.62,13.8,18.01,13.65,8.03-.14,15.2-5.25,17.48-13.86Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M778.19,631.66l-48.3.05v-116.93s45.85,0,45.85,0l.21,12.22c10.61-10.72,23.42-14.31,37.76-14.36l-.04,42.81c-7.83-1.14-14.63-1.49-21.2.76-8.65,2.79-13.19,9.51-14.17,18.59l-.1,56.86Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("polygon", {
    points: "719.78 631.65 671.45 631.71 671.45 514.79 719.78 514.78 719.78 631.65"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("polygon", {
    points: "864.41 631.69 816.07 631.69 816.07 514.78 864.4 514.78 864.41 631.69"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M1267.53,594.47c6.94-1.37,12.81,3.31,14.04,9.41,1.31,6.49-2.99,12.77-9.43,14.06-6.23,1.24-12.37-2.69-13.92-8.85s2.13-13.19,9.31-14.62Z"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("circle", {
    cx: "695.61",
    cy: "479.09",
    r: "28.03",
    fill: "#0247fe"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("circle", {
    cx: "841.44",
    cy: "479.09",
    r: "28.03",
    fill: "#fd2107"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "lead",
    "data-rv": "",
    "data-rv-d": "120",
    style: {
      maxWidth: "32ch",
      margin: "0"
    }
  }, "T\xFA tomas las decisiones de tu negocio. La red sostiene el sistema que las hace posibles.")))), (0,emotion_react_browser_esm/* jsx */.tZ)("section", {
    className: "sec sec-800",
    id: "perfil"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "glow",
    "aria-hidden": "true"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "wrap"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "eyebrow",
    "data-rv": ""
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "bar"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "num"
  }, "03"), " El perfil"), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "split"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("h2", {
    className: "d2",
    "data-rv": ""
  }, "No necesitas ser", (0,emotion_react_browser_esm/* jsx */.tZ)("br", null), (0,emotion_react_browser_esm/* jsx */.tZ)("em", {
    className: "h-acc"
  }, "agente inmobiliario.")), (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "lead",
    "data-rv": "",
    "data-rv-d": "80"
  }, "Necesitas visi\xF3n, gesti\xF3n y liderazgo. Si sabes construir relaciones y tomar decisiones de negocio, ya tienes lo que este modelo exige. Lo dem\xE1s se aprende dentro de la estructura."), (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "micro",
    "data-rv": "",
    "data-rv-d": "140",
    style: {
      marginTop: "var(--s4)"
    }
  }, "El perfil ideal es gestor y l\xEDder, no vendedor de campo."))), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "prof"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "p"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "ix"
  }, "01"), (0,emotion_react_browser_esm/* jsx */.tZ)("h3", null, "Empresarios y due\xF1os de negocio"), (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, "Ya saben lo que cuesta sostener una operaci\xF3n y quieren diversificar con una marca probada.")), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "p"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "ix"
  }, "02"), (0,emotion_react_browser_esm/* jsx */.tZ)("h3", null, "Profesionales liberales"), (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, "Abogados, contadores y consultores con pr\xE1ctica propia y una red de relaciones construida.")), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "p"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "ix"
  }, "03"), (0,emotion_react_browser_esm/* jsx */.tZ)("h3", null, "Ejecutivos y gerentes"), (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, "Con experiencia dirigiendo equipos y resultados, listos para hacerlo por cuenta propia.")), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "p"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "ix"
  }, "04"), (0,emotion_react_browser_esm/* jsx */.tZ)("h3", null, "Banca, seguros y servicios financieros"), (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, "Entienden de confianza, cartera y decisiones patrimoniales. Es el mismo m\xFAsculo.")), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "p"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "ix"
  }, "05"), (0,emotion_react_browser_esm/* jsx */.tZ)("h3", null, "Comercio y sector productivo"), (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, "Gestionan inventario, personal y clientes todos los d\xEDas. Dirigir una oficina no es distinto.")), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "p"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "ix"
  }, "06"), (0,emotion_react_browser_esm/* jsx */.tZ)("h3", null, "Sector inmobiliario"), (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, "Quienes ya conocen el mercado y quieren pasar de operar dentro de una oficina a dirigir la suya."))), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "split",
    style: {
      marginTop: "clamp(48px,7vw,88px)",
      alignItems: "center"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "ph",
    "data-rv-ph": "",
    style: {
      aspectRatio: "4/5"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("img", {
    src: "/franquicias/img/perfil.webp",
    alt: "Profesionales dominicanos conversando sobre un proyecto de negocio",
    width: "1200",
    height: "1500",
    loading: "lazy",
    srcSet: "/franquicias/img/perfil-480.webp 480w, /franquicias/img/perfil-800.webp 800w, /franquicias/img/perfil-1200.webp 1200w",
    sizes: "(max-width: 760px) 100vw, 50vw",
    decoding: "async"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "d3 quote-pull",
    "data-rv": ""
  }, "La experiencia puede venir de otro sector.", (0,emotion_react_browser_esm/* jsx */.tZ)("br", null), "Lo que importa es saber relacionarte y gestionar.")), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "cta-band",
    "data-rv": ""
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, (0,emotion_react_browser_esm/* jsx */.tZ)("h3", null, "\xBFTe reconoces en alguno de estos perfiles?"), (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, "Agenda una reuni\xF3n de presentaci\xF3n y eval\xFAalo con datos, no con suposiciones.")), (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    className: "btn btn-1",
    href: "#reunion"
  }, "Solicita tu reuni\xF3n", (0,emotion_react_browser_esm/* jsx */.tZ)("svg", {
    className: "arrow",
    width: "20",
    height: "14",
    viewBox: "0 0 20 14",
    fill: "none",
    "aria-hidden": "true"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M1 7h17M12 1l6 6-6 6",
    stroke: "currentColor",
    strokeWidth: "2.4",
    strokeLinecap: "square"
  })))))), (0,emotion_react_browser_esm/* jsx */.tZ)("section", {
    className: "sec sec-700",
    id: "incluye"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "wrap"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "eyebrow",
    "data-rv": ""
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "bar"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "num"
  }, "04"), " Qu\xE9 recibes"), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "split"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("h2", {
    className: "d2",
    "data-rv": ""
  }, "Emprender no significa", (0,emotion_react_browser_esm/* jsx */.tZ)("br", null), (0,emotion_react_browser_esm/* jsx */.tZ)("em", {
    className: "h-acc"
  }, "empezar solo.")), (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "lead",
    "data-rv": "",
    "data-rv-d": "80"
  }, "La idea es tuya. El camino no tienes que improvisarlo. Esto es lo que ya est\xE1 montado el d\xEDa que abres tu oficina.")), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "split",
    style: {
      marginTop: "var(--s7)",
      alignItems: "start"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("ol", {
    className: "incl",
    "data-rv": "",
    style: {
      marginTop: "0"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("li", null, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "ix"
  }, "01"), (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, (0,emotion_react_browser_esm/* jsx */.tZ)("h3", null, "Una marca reconocida"), (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, "Entras al mercado con un nombre que el cliente ya identifica, en lugar de construir reputaci\xF3n desde cero."))), (0,emotion_react_browser_esm/* jsx */.tZ)("li", null, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "ix"
  }, "02"), (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, (0,emotion_react_browser_esm/* jsx */.tZ)("h3", null, "Tecnolog\xEDa y CRM desde el d\xEDa uno"), (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, "Las herramientas de gesti\xF3n de cartera, clientes y equipo est\xE1n operativas antes de tu primera venta."))), (0,emotion_react_browser_esm/* jsx */.tZ)("li", null, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "ix"
  }, "03"), (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, (0,emotion_react_browser_esm/* jsx */.tZ)("h3", null, "Capacitaci\xF3n estructurada"), (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, "Formaci\xF3n para ti como due\xF1o y para los agentes que vayas incorporando, con contenido y calendario definidos."))), (0,emotion_react_browser_esm/* jsx */.tZ)("li", null, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "ix"
  }, "04"), (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, (0,emotion_react_browser_esm/* jsx */.tZ)("h3", null, "Red global y regional"), (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, "Referidos, buenas pr\xE1cticas y contacto con oficinas que ya resolvieron los problemas que t\xFA vas a enfrentar."))), (0,emotion_react_browser_esm/* jsx */.tZ)("li", null, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "ix"
  }, "05"), (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, (0,emotion_react_browser_esm/* jsx */.tZ)("h3", null, "Acompa\xF1amiento continuo"), (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, "No termina con la apertura. Hay soporte durante la puesta en marcha y en la operaci\xF3n del d\xEDa a d\xEDa."))), (0,emotion_react_browser_esm/* jsx */.tZ)("li", null, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "ix"
  }, "06"), (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, (0,emotion_react_browser_esm/* jsx */.tZ)("h3", null, "Desarrollo de agentes"), (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, "Un sistema para reclutar, formar y retener el equipo, que es donde realmente se multiplica el negocio.")))), (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "ph",
    "data-rv-ph": "",
    style: {
      aspectRatio: "4/5"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("img", {
    src: "/franquicias/img/respaldo.webp",
    alt: "Sesi\xF3n de capacitaci\xF3n de un equipo dentro de una oficina",
    width: "1200",
    height: "1500",
    loading: "lazy",
    srcSet: "/franquicias/img/respaldo-480.webp 480w, /franquicias/img/respaldo-800.webp 800w, /franquicias/img/respaldo-1200.webp 1200w",
    sizes: "(max-width: 760px) 100vw, 50vw",
    decoding: "async"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "note",
    "data-rv": ""
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("b", null, "Sobre la inversi\xF3n."), " La apertura de una franquicia requiere una inversi\xF3n inicial. Las condiciones vigentes, el desglose completo y los territorios disponibles se presentan en la reuni\xF3n, no por anuncio ni por correo. Es una decisi\xF3n de negocio y merece conversarse con la informaci\xF3n completa."))))), (0,emotion_react_browser_esm/* jsx */.tZ)("section", {
    className: "sec light",
    id: "camino"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "wrap"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "eyebrow",
    "data-rv": ""
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "bar"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "num"
  }, "05"), " El camino"), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "split"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("h2", {
    className: "d2",
    "data-rv": ""
  }, "Cuatro pasos entre", (0,emotion_react_browser_esm/* jsx */.tZ)("br", null), (0,emotion_react_browser_esm/* jsx */.tZ)("em", {
    className: "h-acc"
  }, "hoy y tu oficina.")), (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "lead",
    "data-rv": "",
    "data-rv-d": "80"
  }, "Sin letra peque\xF1a y sin compromisos antes de tiempo. Cada paso existe para que ambas partes decidan con informaci\xF3n real.")), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "split",
    style: {
      marginTop: "var(--s7)",
      alignItems: "start"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "path-wrap",
    id: "pathWrap"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "step"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "ix"
  }, "Paso 01"), (0,emotion_react_browser_esm/* jsx */.tZ)("h3", null, "Solicitas la reuni\xF3n"), (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, "Respondes cuatro preguntas y eliges el d\xEDa que te conviene. Menos de un minuto.")), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "step"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "ix"
  }, "Paso 02"), (0,emotion_react_browser_esm/* jsx */.tZ)("h3", null, "Reuni\xF3n de presentaci\xF3n"), (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, "Conoces el modelo completo, el respaldo que recibes y las condiciones de inversi\xF3n. Preguntas todo lo que necesites.")), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "step"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "ix"
  }, "Paso 03"), (0,emotion_react_browser_esm/* jsx */.tZ)("h3", null, "Evaluaci\xF3n conjunta"), (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, "Revisamos tu perfil, la zona que te interesa y la disponibilidad de territorio. Aqu\xED se decide si el modelo encaja contigo y t\xFA con \xE9l.")), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "step"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "ix"
  }, "Paso 04"), (0,emotion_react_browser_esm/* jsx */.tZ)("h3", null, "Apertura y equipo"), (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, "Adecuaci\xF3n del local, instalaci\xF3n de la tecnolog\xEDa, capacitaci\xF3n e incorporaci\xF3n de tus primeros agentes."))), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "ph",
    "data-rv-ph": "",
    style: {
      aspectRatio: "1/1"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("img", {
    src: "/franquicias/img/reunion.webp",
    alt: "Reuni\xF3n de presentaci\xF3n entre un representante y candidatos a franquicia",
    width: "1200",
    height: "1200",
    loading: "lazy",
    srcSet: "/franquicias/img/reunion-480.webp 480w, /franquicias/img/reunion-800.webp 800w, /franquicias/img/reunion-1200.webp 1200w",
    sizes: "(max-width: 760px) 100vw, 50vw",
    decoding: "async"
  }))))), (0,emotion_react_browser_esm/* jsx */.tZ)("section", {
    className: "sec sec-800",
    id: "reunion"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "glow",
    "aria-hidden": "true"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "wrap"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "eyebrow",
    "data-rv": ""
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "bar"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "num"
  }, "06"), " Solicita tu reuni\xF3n"), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "form-grid"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("aside", {
    className: "form-aside"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("h2", {
    className: "d2",
    "data-rv": ""
  }, "Lo que ver\xE1s", (0,emotion_react_browser_esm/* jsx */.tZ)("br", null), (0,emotion_react_browser_esm/* jsx */.tZ)("em", {
    className: "h-acc"
  }, "en la reuni\xF3n.")), (0,emotion_react_browser_esm/* jsx */.tZ)("ul", {
    "data-rv": "",
    "data-rv-d": "80"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("li", null, "Conoces el modelo completo y qu\xE9 incluye el respaldo de la red"), (0,emotion_react_browser_esm/* jsx */.tZ)("li", null, "Revisas las condiciones de inversi\xF3n con cifras concretas"), (0,emotion_react_browser_esm/* jsx */.tZ)("li", null, "Eval\xFAas la disponibilidad de territorio en la zona que te interesa")), (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "sla",
    "data-rv": "",
    "data-rv-d": "140"
  }, "Un representante de REMAX Rep\xFAblica Dominicana confirma tu reuni\xF3n dentro de las pr\xF3ximas 24 horas. Tus datos se usan \xFAnicamente para coordinar esta conversaci\xF3n.")), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "card",
    "data-rv": "",
    "data-rv-d": "60"
  }, withoutForm === null ? (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    "aria-busy": "true",
    style: {
      minHeight: 320
    }
  }) : withoutForm ? (0,emotion_react_browser_esm/* jsx */.tZ)(DirectCalendar, null) : (0,emotion_react_browser_esm/* jsx */.tZ)(FranchiseForm, {
    live: live
  }))))), (0,emotion_react_browser_esm/* jsx */.tZ)("section", {
    className: "sec sec-700",
    id: "faq"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "wrap"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "eyebrow",
    "data-rv": ""
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "bar"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "num"
  }, "07"), " Preguntas frecuentes"), (0,emotion_react_browser_esm/* jsx */.tZ)("h2", {
    className: "d2",
    "data-rv": ""
  }, "Lo que casi todos", (0,emotion_react_browser_esm/* jsx */.tZ)("br", null), "preguntan primero."), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "faq",
    "data-rv": "",
    "data-rv-d": "60"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("details", null, (0,emotion_react_browser_esm/* jsx */.tZ)("summary", null, "\xBFNecesito experiencia en bienes ra\xEDces para abrir una franquicia?"), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "a"
  }, "No. El due\xF1o de oficina no vende propiedades: recluta, organiza, lidera y hace crecer un equipo. Lo que se necesita es visi\xF3n, gesti\xF3n y liderazgo. Buena parte de los perfiles que mejor encajan vienen de banca, seguros, derecho, comercio y otras profesiones liberales.")), (0,emotion_react_browser_esm/* jsx */.tZ)("details", null, (0,emotion_react_browser_esm/* jsx */.tZ)("summary", null, "\xBFCu\xE1l es la diferencia real entre ser agente y ser due\xF1o de oficina?"), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "a"
  }, "El agente trabaja dentro de una estructura que otro cre\xF3 y sus ingresos dependen del tiempo que \xE9l dedica. El due\xF1o crea esa estructura, define la cultura y construye un activo que le pertenece, cuyo resultado crece con el equipo que multiplica. Si lo que buscas es desarrollarte como agente, ese es otro proceso y tambi\xE9n est\xE1 abierto.")), (0,emotion_react_browser_esm/* jsx */.tZ)("details", null, (0,emotion_react_browser_esm/* jsx */.tZ)("summary", null, "\xBFCu\xE1nto se necesita para abrir?"), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "a"
  }, "La apertura requiere una inversi\xF3n inicial. Las condiciones vigentes y el desglose completo se presentan en la reuni\xF3n, con las cifras validadas al momento de la conversaci\xF3n. En el formulario preguntamos por rangos \xFAnicamente para preparar una presentaci\xF3n ajustada a tu situaci\xF3n; ninguna respuesta te descarta.")), (0,emotion_react_browser_esm/* jsx */.tZ)("details", null, (0,emotion_react_browser_esm/* jsx */.tZ)("summary", null, "\xBFEn qu\xE9 zonas del pa\xEDs puedo abrir mi oficina?"), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "a"
  }, "La prioridad actual est\xE1 en el interior del pa\xEDs: Santiago, La Vega y Bonao, San Francisco de Macor\xEDs y el Nordeste, Puerto Plata y la Costa Norte, y San Crist\xF3bal y el Sur. El Este y el Distrito Nacional tambi\xE9n se atienden. La disponibilidad de territorio en tu zona se confirma en la reuni\xF3n.")), (0,emotion_react_browser_esm/* jsx */.tZ)("details", null, (0,emotion_react_browser_esm/* jsx */.tZ)("summary", null, "\xBFQu\xE9 incluye exactamente el respaldo de la red?"), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "a"
  }, "Una marca reconocida, tecnolog\xEDa y CRM operativos desde el d\xEDa uno, capacitaci\xF3n estructurada para ti y para tus agentes, acceso a la red global y regional, y acompa\xF1amiento continuo durante la apertura y la operaci\xF3n. No compras un logo: entras a una estructura que ya funciona.")), (0,emotion_react_browser_esm/* jsx */.tZ)("details", null, (0,emotion_react_browser_esm/* jsx */.tZ)("summary", null, "\xBFQu\xE9 pasa despu\xE9s de que env\xEDo el formulario?"), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "a"
  }, "Un representante de REMAX Rep\xFAblica Dominicana te contacta dentro de las pr\xF3ximas 24 horas para confirmar la reuni\xF3n de presentaci\xF3n en el horario que elegiste. Tus datos se usan \xFAnicamente para coordinar esa conversaci\xF3n, seg\xFAn la", " ", (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    href: "/politica-privacidad",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "pol\xEDtica de privacidad"), "."))))), (0,emotion_react_browser_esm/* jsx */.tZ)("section", {
    className: "final"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "final-bg",
    "aria-hidden": "true"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("img", {
    src: "/franquicias/img/cierre.webp",
    alt: "",
    width: "2400",
    height: "1200",
    loading: "lazy",
    srcSet: "/franquicias/img/cierre-480.webp 480w, /franquicias/img/cierre-800.webp 800w, /franquicias/img/cierre-1200.webp 1200w",
    sizes: "100vw",
    decoding: "async"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "wrap"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("img", {
    src: "/franquicias/img/identificador_tu_diriges_geometrico_oficial-wht.webp",
    alt: "T\xFA diriges. REMAX respalda.",
    width: "1107",
    height: "810",
    loading: "lazy",
    "data-rv-clip": "",
    decoding: "async"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("h2", {
    className: "d2",
    "data-rv": ""
  }, "La pr\xF3xima historia", (0,emotion_react_browser_esm/* jsx */.tZ)("br", null), (0,emotion_react_browser_esm/* jsx */.tZ)("em", {
    className: "h-acc"
  }, "puede ", (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "acc"
  }, "comenzar contigo"), ".")), (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "lead",
    "data-rv": "",
    "data-rv-d": "80",
    style: {
      textAlign: "center"
    }
  }, "Empez\xF3 con una duda: querer emprender sin saber por d\xF3nde. Hoy hay un modelo probado del otro lado de una conversaci\xF3n de 45 minutos."), (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    className: "btn btn-1",
    href: "#reunion",
    "data-rv": "",
    "data-rv-d": "140"
  }, "Solicita tu reuni\xF3n de presentaci\xF3n", (0,emotion_react_browser_esm/* jsx */.tZ)("svg", {
    className: "arrow",
    width: "20",
    height: "14",
    viewBox: "0 0 20 14",
    fill: "none",
    "aria-hidden": "true"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("path", {
    d: "M1 7h17M12 1l6 6-6 6",
    stroke: "currentColor",
    strokeWidth: "2.4",
    strokeLinecap: "square"
  })))))), (0,emotion_react_browser_esm/* jsx */.tZ)("footer", {
    className: "ft"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "wrap ft-in"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: "logo-dark"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("img", {
    src: "/franquicias/img/logo-remax-neg.webp",
    alt: "REMAX Rep\xFAblica Dominicana",
    width: "1797",
    height: "536",
    loading: "lazy",
    decoding: "async"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)("nav", {
    "aria-label": "Enlaces del pie de p\xE1gina"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    href: "#modelo"
  }, "El modelo"), (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    href: "#perfil"
  }, "\xBFEs para ti?"), (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    href: "#faq"
  }, "Preguntas frecuentes"), (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    href: "/politica-privacidad",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Pol\xEDtica de privacidad"), (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    href: "https://reclutamiento.remaxrd.com/?utm_source=landing_franquicias&utm_medium=footer&utm_id=campaign_franquicias",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Quiero ser agente")), (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "ft-legal"
  }, "\xA9 ", (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    id: "yr"
  }, "2026"), " REMAX Rep\xFAblica Dominicana. Cada oficina es de propiedad y operaci\xF3n independiente. Esta p\xE1gina presenta informaci\xF3n general sobre el modelo de franquicia y no constituye una oferta de venta de franquicia. Las condiciones vigentes se entregan durante la reuni\xF3n de presentaci\xF3n.")), (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    className: "developer-credit"
  }, "DESARROLLADO POR ", (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    href: "http://version.do",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "VERSION DO"))));
}
;// CONCATENATED MODULE: ./pages/franquicias/index.tsx




var title = "Dirige tu propia oficina REMAX · Franquicias REMAX República Dominicana";
var description = "Una franquicia REMAX es un negocio propio, no una vacante de agente. Diriges tu oficina, formas tu equipo y construyes un activo que te pertenece. Solicita tu reunión de presentación.";
var __N_SSG = true;
function FranchiseLanding(_ref) {
  var siteUrl = _ref.siteUrl,
      live = _ref.live;
  var url = siteUrl + "/franquicias";
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)((head_default()), null, (0,emotion_react_browser_esm/* jsx */.tZ)("title", null, title), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    name: "description",
    content: description
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    name: "viewport",
    content: "width=device-width, initial-scale=1",
    key: "viewport"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    name: "robots",
    content: "index,follow",
    key: "robots"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("link", {
    rel: "canonical",
    href: url,
    key: "canonical"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("link", {
    rel: "icon",
    href: "/franquicias/favicon.svg",
    type: "image/svg+xml",
    key: "favicon"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("link", {
    rel: "preload",
    href: "/franquicias/fonts/montserrat.woff2",
    as: "font",
    type: "font/woff2",
    crossOrigin: "anonymous"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("link", {
    rel: "preload",
    href: "/franquicias/fonts/playfair-italic.woff2",
    as: "font",
    type: "font/woff2",
    crossOrigin: "anonymous"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    property: "og:type",
    content: "website"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    property: "og:locale",
    content: "es_DO"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    property: "og:site_name",
    content: "REMAX Rep\xFAblica Dominicana"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    property: "og:title",
    content: title
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    property: "og:description",
    content: description
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    property: "og:url",
    content: url
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    property: "og:image",
    content: siteUrl + "/franquicias/img/hero-bg.webp"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    name: "twitter:card",
    content: "summary_large_image"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: title,
        description: description,
        url: url,
        inLanguage: "es-DO",
        about: {
          "@type": "Organization",
          name: "REMAX República Dominicana",
          url: siteUrl
        }
      }).replace(/</g, "\\u003c")
    }
  })), (0,emotion_react_browser_esm/* jsx */.tZ)("noscript", null, (0,emotion_react_browser_esm/* jsx */.tZ)("style", null, ".franchise-landing [data-rv],.franchise-landing [data-rv-clip],.franchise-landing .ph {opacity:1!important;transform:none!important;clip-path:none!important}"), (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    style: {
      padding: 20
    }
  }, "Activa JavaScript para utilizar el formulario y el calendario.")), (0,emotion_react_browser_esm/* jsx */.tZ)(LandingContent, {
    live: live
  }));
}
FranchiseLanding.standalone = true;

/***/ }),

/***/ 76873:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/franquicias",
      function () {
        return __webpack_require__(42444);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72717)


/***/ }),

/***/ 52587:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 14666:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),

/***/ 10748:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ 50029:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ 92777:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 82262:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),

/***/ 59499:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 37247:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ 81531:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90607);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 14882:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),

/***/ 63553:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var next_dist_compiled_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14027);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10748);


function _possibleConstructorReturn(self, call) {
  if (call && (next_dist_compiled_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(self);
}

/***/ }),

/***/ 90607:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 17674:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(14666);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(2937);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(14882);
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return (0,arrayWithHoles/* default */.Z)(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || (0,nonIterableRest/* default */.Z)();
}

/***/ }),

/***/ 2937:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52587);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2888,9774,179], function() { return __webpack_exec__(76873); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);